import React, { useCallback, useEffect, useRef, useState } from "react";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";

// Components
import { InputField } from "../../../../Components/formElements/InputField";
import FileUploadComponent from "../../../../Components/formElements/FileUploadComponent";
// import FileViewerModal from "../../../../Components/FileViewer/FileViewerModal";
import toast from "react-hot-toast";

//Serivce
import ItemService from "../../../../services/customer_appCommonService";
import { TextAreaField } from "../../../../Components/formElements/TextAreaField";
import { useDispatch, useSelector } from "react-redux";
import ShowUploadImageV5 from "./ShowUploadImageV5";
// import { validateRequired } from "../../../../common/Validations";
import FailureModal from "../../../../Components/Modal/supplier_app/FailureModal";
import { ComboboxField } from "../../../../Components/formElements/ComboboxField";
// import { MultiselectField } from "../../../../Components/formElements/MultiselectField";
import { getMaterialList } from "../../../../redux/feature/customer_app/customerSlice";
import { validateRequired } from "../../../../common/Validations";
import DataTable from "react-data-table-component";
import CustomerConstants from "../../../../common/CustomerConstants";
import { SearchField } from "../../../../Components/formElements/SearchField";
import FileUploadComponentForHB from "../../../../Components/formElements/FileUploadComponentForHB";
import FileViewerModalForHB from "../../../../Components/FileViewer/FileViewerModalForHB";
import { MultiselectFieldMrErf } from "../../../../Components/formElements/MultiselectFieldMrErf";

const MaterialHBModalV5 = React.forwardRef((props, ref) => {
  const message = {
    VALID_CUSTOMER_NAME: "Special characters or numbers are not allowed.",
    VALID_MAIL_ID: "Please enter a valid email address.",
    VALID_ALTERNATE_MAIL_ID: "Please enter a valid alternate email address.",
    VALID_CONTACT_NUMBER: "Please enter a valid contact number.",
    VALID_ALTERNATE_CONTACT_NUMBER:
      "Please enter a valid alternate contact number.",
    VALID_PURPOSE_JUSTIFICATION:
      "Please ensure the justification is under 500 characters.",
    VALID_POSTAL_CODE:
      "Enter a 6-character postal code with uppercase letters and numbers only",
    VALID_CONTACT_FIRST_NAME: "Special characters and numbers are not allowed",
    VALID_CONTACT_LAST_NAME: "Special characters and numbers are not allowed",
    EXIStS_MAIL_ID: "Email already exists",
    EXIStS_CONTACT_NUMBER: "Contact Number already exists",
    EXIStS_ALTERNATE_CONTACT_NUMBER: "Contact Number already exists",
    EXIStS_ALTERNATE_MAIL_ID: "Alternate Contact Number already exists",
    FILL_REQUIRED_FIELD: "Please fill the required field",
    ALTERNATE_MAIL_ID: "Email ID is same",
    ALTERNATE_CONTACT_NUMBER: "Contact number is same",
  };

  let materialNr = useSelector(
    (state) => state?.customerV1?.material?.materialNr,
  );

  const dispatch = useDispatch();
  const initialFormInputsRef = useRef(null);
  const [accessoriesCode, setaccessoriesCode] = useState();

  const [formInputs, setFormInputs] = useState({
    materialAttachments: "",
    materialImage: "",
    hospital: [],
    purchaseQuantity: 1,
    accessories: false,
    accessoriesCode: [],
  });

  const failureModalData = {
    title: "Warning",
    ErrorMsg: "",
  };
  const units = [
    { id: 1, name: "UNIT", code: "UN", description: "UNIT" },
    { id: 2, name: "PCS", code: "PC", description: "PCS" },
    { id: 3, name: "ROLL", code: "RL", description: "ROLL" },
    { id: 4, name: "SELECT", code: "SE", description: "SELECT" },
    { id: 5, name: "KG", code: "KG", description: "KG" },
    { id: 6, name: "BOX", code: "BX", description: "BOX" },
    { id: 7, name: "PKT", code: "PK", description: "PKT" },
    { id: 8, name: "PAIR", code: "PR", description: "PAIR" },
    { id: 9, name: "PACKET", code: "PA", description: "PACKET" },
    { id: 10, name: "SET", code: "ST", description: "SET" },
    { id: 11, name: "SHEET", code: "SH", description: "SHEET" },
    { id: 12, name: "METER", code: "MT", description: "METER" },
    { id: 13, name: "CONE", code: "CN", description: "CONE" },
    { id: 14, name: "U", code: "U", description: "U" },
    { id: 15, name: "FEET", code: "FT", description: "FEET" },
    { id: 16, name: "MTR", code: "MT", description: "MTR" },
    { id: 17, name: "PCS", code: "PC", description: "PCS" },
    { id: 18, name: "KG", code: "KG", description: "KG" },
    { id: 19, name: "LTR", code: "LT", description: "LTR" },
    { id: 20, name: "SQINCH", code: "SI", description: "SQINCH" },
    { id: 21, name: "PAIRS", code: "PR", description: "PAIRS" },
    { id: 22, name: "SQFT", code: "SF", description: "SQFT" },
    { id: 23, name: "LTR", code: "LT", description: "LTR" },
    { id: 24, name: "NULL", code: "NA", description: "NULL" },
    { id: 25, name: "STICK", code: "SK", description: "STICK" },
    { id: 26, name: "RIM", code: "RM", description: "RIM" },
  ];

  // const materialGroups = [
  //   { id: 1, name: "WALKING AIDS", code: "WA", description: "WALKING AIDS" },
  //   { id: 2, name: "WALKING STICK", code: "WS", description: "WALKING STICK" },
  //   { id: 3, name: "CRUTCHES", code: "CR", description: "CRUTCHES" },
  //   { id: 4, name: "WALKER", code: "WK", description: "WALKER" },
  //   { id: 5, name: "ROLLATORS", code: "RL", description: "ROLLATORS" },

  //   {
  //     id: 6,
  //     name: "RESPIRATORY CARE",
  //     code: "RC",
  //     description: "RESPIRATORY CARE",
  //   },
  //   { id: 7, name: "CPAP MACHINE", code: "CPAP", description: "CPAP MACHINE" },
  //   { id: 8, name: "BIPAP", code: "BIPAP", description: "BIPAP" },
  //   { id: 9, name: "VENTILATORS", code: "VENT", description: "VENTILATORS" },
  //   {
  //     id: 10,
  //     name: "OXYGEN CYLINDER",
  //     code: "OC",
  //     description: "OXYGEN CYLINDER",
  //   },
  //   {
  //     id: 11,
  //     name: "PULSE OXIMETER",
  //     code: "PO",
  //     description: "PULSE OXIMETER",
  //   },
  //   {
  //     id: 12,
  //     name: "OXYGEN CONCENTRATOR",
  //     code: "OXC",
  //     description: "OXYGEN CONCENTRATOR",
  //   },
  //   { id: 13, name: "NEBULIZER", code: "NEB", description: "NEBULIZER" },

  //   {
  //     id: 14,
  //     name: "PATIENT TRANSFER",
  //     code: "PT",
  //     description: "PATIENT TRANSFER",
  //   },
  //   { id: 15, name: "WHEEL CHAIRS", code: "WC", description: "WHEEL CHAIRS" },
  //   { id: 16, name: "STAIR CHAIR", code: "SC", description: "STAIR CHAIR" },
  //   { id: 17, name: "PATIENT LIFT", code: "PL", description: "PATIENT LIFT" },
  //   { id: 18, name: "STRETCHER", code: "STR", description: "STRETCHER" },

  //   { id: 19, name: "AIR MATTRESS", code: "AM", description: "AIR MATTRESS" },
  //   {
  //     id: 20,
  //     name: "TUBE AIR MATTRESS",
  //     code: "TAM",
  //     description: "TUBE AIR MATTRESS",
  //   },
  //   {
  //     id: 21,
  //     name: "BUBBLE AIR MATTRESS",
  //     code: "BAM",
  //     description: "BUBBLE AIR MATTRESS",
  //   },
  //   { id: 22, name: "WATER BED", code: "WB", description: "WATER BED" },

  //   {
  //     id: 23,
  //     name: "PATIENT CLOTHING",
  //     code: "PC",
  //     description: "PATIENT CLOTHING",
  //   },
  //   { id: 24, name: "GOWN", code: "GWN", description: "GOWN" },
  //   { id: 25, name: "LOWER", code: "LWR", description: "LOWER" },
  //   { id: 26, name: "SUIT", code: "SUT", description: "SUIT" },

  //   { id: 27, name: "BACK CARE", code: "BC", description: "BACK CARE" },
  //   { id: 28, name: "BACKREST", code: "BR", description: "BACKREST" },
  //   { id: 29, name: "LS BELT", code: "LSB", description: "LS BELT" },
  //   { id: 30, name: "TAYLOR BRACE", code: "TB", description: "TAYLOR BRACE" },

  //   { id: 31, name: "NECK CARE", code: "NC", description: "NECK CARE" },
  //   { id: 32, name: "NECKREST", code: "NR", description: "NECKREST" },
  //   {
  //     id: 33,
  //     name: "CERVICAL PILLOW",
  //     code: "CP",
  //     description: "CERVICAL PILLOW",
  //   },
  //   {
  //     id: 34,
  //     name: "CERVICAL COLLAR",
  //     code: "CC",
  //     description: "CERVICAL COLLAR",
  //   },
  //   {
  //     id: 35,
  //     name: "PHILADELPHIA COLLAR",
  //     code: "PCO",
  //     description: "PHILADELPHIA COLLAR",
  //   },

  //   { id: 36, name: "MOTHER CARE", code: "MC", description: "MOTHER CARE" },
  //   {
  //     id: 37,
  //     name: "MATERNITY BELT",
  //     code: "MB",
  //     description: "MATERNITY BELT",
  //   },
  //   { id: 38, name: "BREAST PUMP", code: "BP", description: "BREAST PUMP" },
  //   { id: 39, name: "BABY BLANKET", code: "BB", description: "BABY BLANKET" },
  //   {
  //     id: 40,
  //     name: "BREATHABLE MAC SHEET",
  //     code: "BMS",
  //     description: "BREATHABLE MAC SHEET",
  //   },
  //   {
  //     id: 41,
  //     name: "SILICONE BABY PRODUCT",
  //     code: "SBP",
  //     description: "SILICONE BABY PRODUCT",
  //   },

  //   { id: 42, name: "KNEE CARE", code: "KC", description: "KNEE CARE" },
  //   { id: 43, name: "KNEE CAP", code: "KCAP", description: "KNEE CAP" },
  //   {
  //     id: 44,
  //     name: "HINGED KNEE BRACE",
  //     code: "HKB",
  //     description: "HINGED KNEE BRACE",
  //   },
  //   {
  //     id: 45,
  //     name: "KNEE IMMOBILIZER",
  //     code: "KI",
  //     description: "KNEE IMMOBILIZER",
  //   },
  //   { id: 46, name: "ROM BRACE", code: "ROM", description: "ROM BRACE" },

  //   { id: 47, name: "FOOT CARE", code: "FC", description: "FOOT CARE" },
  //   { id: 48, name: "TOE CARE", code: "TC", description: "TOE CARE" },
  //   { id: 49, name: "FOOT WEAR", code: "FW", description: "FOOT WEAR" },
  //   { id: 50, name: "HEALTH SOCKS", code: "HS", description: "HEALTH SOCKS" },
  //   {
  //     id: 51,
  //     name: "SILICONE HEEL PRODUCTS",
  //     code: "SHP",
  //     description: "SILICONE HEEL PRODUCTS",
  //   },
  //   {
  //     id: 52,
  //     name: "SILICONE INSOLES",
  //     code: "SI",
  //     description: "SILICONE INSOLES",
  //   },

  //   { id: 53, name: "SCAR CARE", code: "SCAR", description: "SCAR CARE" },
  // ];
  const mfgBy = [
    { id: 1, name: "NA" },
    { id: 2, name: "XAMAX" },
    { id: 3, name: "NORMA" },
    { id: 4, name: "MEDIRENT" },
    { id: 5, name: "UNI-EM" },
    { id: 6, name: "ANAND" },
    { id: 7, name: "Bharat Healthcare" },
    { id: 8, name: "Hochste Healthcare" },
  ];
  const mktBy = [
    { id: 2, name: "XAMAX" },
    { id: 3, name: "NORMA" },
    { id: 4, name: "MEDIRENT" },
    { id: 6, name: "ANAND" },
  ];
  const importedBy = [
    { id: 1, name: "XAMAX" },
    { id: 2, name: "NORMA" },
    { id: 3, name: "MEDIRENT" },
    { id: 4, name: "PHILIPS" },
    { id: 5, name: "UTTAM" },
    { id: 6, name: "ADREM" },
    { id: 7, name: "BHARAT HEALTHCARE" },
    { id: 8, name: "YOGI KRIPA" },
    { id: 9, name: "ANAND" },
    { id: 10, name: "LUXFER UTTAM" },
    { id: 11, name: "DARCO" },
    { id: 12, name: "PHILIPS1" },
    { id: 13, name: "Universal Medical Instruments" },
    { id: 14, name: "MEDIEQUIP" },
  ];

  const categories = [
    { id: 1, name: "Not Applicable" },
    { id: 2, name: "ALUMINIUM STAYS" },
    { id: 3, name: "BABY_CARE_RANGE" },
    { id: 4, name: "BATHROOM_TOILET_PRODUCTS" },
    { id: 5, name: "BED SORES PREVENTION RANGE" },
    { id: 6, name: "BRACES / SPLINTS" },
    { id: 7, name: "COMPRESSION GARMENTS" },
    { id: 8, name: "COMPRESSION GARMENTS ACC." },
    { id: 9, name: "CONSUMABLES" },
    { id: 10, name: "CUSTOM MADE - MEDANTA" },
    { id: 11, name: "DAMAGE/LOST PARTS" },
    { id: 12, name: "DIAGNOSTIC" },
    { id: 13, name: "FITNESS PRODUCT" },
    { id: 14, name: "FOOT CARE_RANGE" },
    { id: 15, name: "GYNECOLOGY" },
    { id: 16, name: "HOSPITAL BED ACC." },
    { id: 17, name: "HOSPITAL BED SPARE" },
    { id: 18, name: "HOSPITAL BEDS" },
    { id: 19, name: "ICU PACKAGE" },
    { id: 20, name: "INFECTION CONTROL" },
    { id: 21, name: "KNEE CARE" },
    { id: 22, name: "LIFESTYLE PRODUCTS" },
    { id: 23, name: "MOBILITY" },
    { id: 24, name: "MOTORIZED RECLINER ACC." },
    { id: 25, name: "MOTORIZED RECLINERS SPARE" },
    { id: 26, name: "OTHERS" },
    { id: 27, name: "OTHERS PRODUCTS" },
    { id: 28, name: "PATIENT CLOTHING" },
    { id: 29, name: "PATIENT TRANSFER PRODUCTS" },
    { id: 30, name: "PREGNANCY_CARE_RANGE" },
    { id: 31, name: "PROSTHESIS PRODUCT" },
    { id: 32, name: "RAW MATERIAL" },
    { id: 33, name: "RAW MATERIAL-SEMI" },
    { id: 34, name: "RECLINERS" },
    { id: 35, name: "REHABLITION PRODUCT" },
    { id: 36, name: "RESPIRATORY" },
    { id: 37, name: "RESPIRATORY ACCESSORIES" },
    { id: 38, name: "SERVICES" },
    { id: 39, name: "VASCULAR CARE" },
    { id: 40, name: "WHEEL CHAIR ACC." },
    { id: 41, name: "WHEEL CHAIRS SPARES" },
  ];

  const subCategories = [
    { id: 1, name: "ADULTS DIAPERS" },
    { id: 2, name: "AIR PURIFIER" },
    { id: 3, name: "ALUMINIUM SHEET" },
    { id: 4, name: "AMBU BAG" },
    { id: 5, name: "ANTI EMBOLISM STOCKING" },
    { id: 6, name: "BACKREST" },
    { id: 7, name: "BATHROOM_SAFETY_PRODUCT" },
    { id: 8, name: "BED DISINFECTANT" },
    { id: 9, name: "BED DISINFECTANT@12%" },
    { id: 10, name: "BED PANS" },
    { id: 11, name: "BED SIDE LOCKER" },
    { id: 12, name: "BED SIDE RAILS" },
    { id: 13, name: "BED SIDE SCREEN" },
    { id: 14, name: "BI-PAP" },
    { id: 15, name: "BI-PAP ACC." },
    { id: 16, name: "BI-PAP ACC.@18%" },
    { id: 17, name: "BREAST PUMP" },
    { id: 18, name: "BREAST PUMP@28%" },
    { id: 19, name: "BREATHABLE MAC SHEET" },
    { id: 20, name: "BUBBLE TUBE MATTRESS" },
    { id: 21, name: "BUBBLE TUBE MATTRESS PUMPS" },
    { id: 22, name: "BUBBLE TUBE MATTRESS SET" },
    { id: 23, name: "C - PAP" },
    { id: 24, name: "C-PAP ACC." },
    { id: 25, name: "CLOCK" },
    { id: 26, name: "CLOTHING" },
    { id: 27, name: "COMFORT CLOTHING" },
    { id: 28, name: "COMMODE CHAIR ACC @28%" },
    { id: 29, name: "COMMODE CHAIRS @18%" },
    { id: 30, name: "COMMODE CHAIRS@5%" },
    { id: 31, name: "COMPRESSION GARMENT ACC.@5%" },
    { id: 32, name: "COVER" },
    { id: 33, name: "CRUTCHES" },
    { id: 34, name: "CUSTOME MADE" },
    { id: 35, name: "DAMAGE/LOST PARTS" },
    { id: 36, name: "DIABETIC SOCKS@12%" },
    { id: 37, name: "DIABETIC SOCKS@5%" },
    { id: 38, name: "DIAGNOSTIC" },
    { id: 39, name: "DIGITAL B.P. MONITOR@12%" },
    { id: 40, name: "DIGITAL B.P. MONITOR@18%" },
    { id: 41, name: "DISINFACTANT SERVICES" },
    { id: 42, name: "DISINFACTANT SERVICES@18%" },
    { id: 43, name: "DISPOSABLE" },
    { id: 44, name: "DISPOSABLE @5%" },
    { id: 45, name: "DRIP STAND" },
    { id: 46, name: "DVT PUMPS" },
    { id: 47, name: "DVT_PUMP_ACC." },
    { id: 48, name: "EASY STEP" },
    { id: 49, name: "ELBOW CRUTCH" },
    { id: 50, name: "ELECTRICITY SERVICES" },
    { id: 51, name: "EXERCISE EQUIPMENT" },
    { id: 52, name: "EXERCISE EQUIPMENT @18%" },
    { id: 53, name: "FEEDING ACC" },
    { id: 54, name: "FIVE FUNTION BED" },
    { id: 55, name: "FOAM MATTRESSES" },
    { id: 56, name: "FOOT CARE" },
    { id: 57, name: "FOOT WEAR" },
    { id: 58, name: "FULL FOWLER BED" },
    { id: 59, name: "GEL POSITIONERS" },
    { id: 60, name: "HARNESS" },
    { id: 61, name: "HEAD & NECK" },
    { id: 62, name: "HOT & COLD THEARPY" },
    { id: 63, name: "HOT & COLD THEARPY @18%" },
    { id: 64, name: "HYGIENE SYSTEM" },
    { id: 65, name: "ICU PACKAGE" },
    { id: 66, name: "INFUSION PUMPS" },
    { id: 67, name: "INVASIVE" },
    { id: 68, name: "LIFESTYLE PRODUCTS" },
    { id: 69, name: "LOWER EXTERMITIES" },
    { id: 70, name: "LOWER EXTERMITIES- B/S" },
    { id: 71, name: "LOWER EXTERMITIES@12%" },
    { id: 72, name: "LYMPHA PRESS" },
    { id: 73, name: "LYMPHA PRESS ACC." },
    { id: 74, name: "MACANTOSH SHEETS" },
    { id: 75, name: "MANUAL" },
    { id: 76, name: "MATERNITY BELT" },
    { id: 77, name: "MISC. @12%" },
    { id: 78, name: "MISC.@5%" },
    { id: 79, name: "MISC@18%" },
    { id: 80, name: "MISC@28%" },
    { id: 81, name: "MOBILITY & FURNITURE" },
    { id: 82, name: "MOSQUITO REPELLENT@18%" },
    { id: 83, name: "MOTORIZED RECLINER" },
    { id: 84, name: "MOTORIZED RECLINERS ACC." },
    { id: 85, name: "MULTI REACHER" },
    { id: 86, name: "NEBULIZER" },
    { id: 87, name: "NEBULIZER ACC." },
    { id: 88, name: "OPTICALS PRODUCTS" },
    { id: 89, name: "OTHER" },
    { id: 90, name: "OTHERS RAW ITEMS@12%" },
    { id: 91, name: "OTHERS RAW ITEMS@18%" },
    { id: 92, name: "OTHERS RAW ITEMS@5%" },
    { id: 93, name: "OVER BED TABLE" },
    { id: 94, name: "OVER BED TRAY" },
    { id: 95, name: "OXYGEN CONCENTRATOR" },
    { id: 96, name: "OXYGEN CONCENTRATOR ACC." },
    { id: 97, name: "OXYGEN CYLINDER" },
    { id: 98, name: "OXYGEN CYLINDER ACC." },
    { id: 99, name: "OXYGEN REFILLING" },
    { id: 100, name: "PACKING MATERIAL" },
    { id: 101, name: "PARAMONITOR" },
    { id: 102, name: "PARAMONITOR ACC." },
    { id: 103, name: "PATIENT LIFT" },
    { id: 104, name: "PATIENT LIFT ACC." },
    { id: 105, name: "PROMOTIONAL MATERIAL" },
    { id: 106, name: "PULSE OXIMETER" },
    { id: 107, name: "RECLINER MATTRESS" },
    { id: 108, name: "REHAB" },
    { id: 109, name: "REPAIR & MAINTENANCE" },
    { id: 110, name: "RESTRAINTS" },
    { id: 111, name: "ROLLATORS" },
    { id: 112, name: "ROOM HUMIDIFIER" },
    { id: 113, name: "SAFETY BAG" },
    { id: 114, name: "SAFETY PRODUCTS" },
    { id: 115, name: "SEAT CUSHION" },
    { id: 116, name: "SEMI FOWLER BED" },
    { id: 117, name: "SERVICES" },
    { id: 118, name: "SHOWER CHAIRS" },
    { id: 119, name: "SHOWER_CHIAR WITH COMMODE" },
    { id: 120, name: "SILICON GELSHEET" },
    { id: 121, name: "SILICONE PRODUCT" },
    { id: 122, name: "SLEEP STUDY" },
    { id: 123, name: "SLEEP STUDY ACC." },
    { id: 124, name: "SPARE PARTS" },
    { id: 125, name: "SPARE PARTS @28%" },
    { id: 126, name: "SPIROMETER" },
    { id: 127, name: "STAIR CHIAR" },
    { id: 128, name: "STEAMER" },
    { id: 129, name: "STOCKING" },
    { id: 130, name: "STOCKINGS READYMADE" },
    { id: 131, name: "STRETCHER" },
    { id: 132, name: "STRETCHER@18%" },
    { id: 133, name: "SUCTION MACH. ACC." },
    { id: 134, name: "SUCTION MACH. ACC. @18%" },
    { id: 135, name: "SUCTION MACHINE" },
    { id: 136, name: "SURFACE PROTECTION@18%" },
    { id: 137, name: "SYRINGE PUMP" },
    { id: 138, name: "TAPE AND BANDAGE" },
    { id: 139, name: "TENS" },
    { id: 140, name: "THERMOMETER" },
    { id: 141, name: "THORACIC / TRUNK" },
    { id: 142, name: "THREE FUNCTION BED" },
    { id: 143, name: "TOILET ARM SUPPORT" },
    { id: 144, name: "TOILET CONVERTORES" },
    { id: 145, name: "TOILET CUSHIONS" },
    { id: 146, name: "TOILET DISINFECTANT" },
    { id: 147, name: "TOILET DISINFECTANT @12%" },
    { id: 148, name: "TOILET DISINFECTANT @18%" },
    { id: 149, name: "TOILET DISINFECTANT @28%" },
    { id: 150, name: "TOILET RAISERS" },
    { id: 151, name: "TOILET STOOL" },
    { id: 152, name: "TOYS & PAG BORDS" },
    { id: 153, name: "UNDER PADS" },
    { id: 154, name: "UPPER EXTERMITIES" },
    { id: 155, name: "URINAL POT" },
    { id: 156, name: "VEINO PLUS" },
    { id: 157, name: "VEINO PLUS ACC." },
    { id: 158, name: "VENTILATOR" },
    { id: 159, name: "VENTILATOR ACC." },
    { id: 160, name: "WALKER" },
    { id: 161, name: "WALKING STICK" },
    { id: 162, name: "WALKING STICK @ 12%" },
    { id: 163, name: "WATER BED" },
    { id: 164, name: "WC ACC." },
    { id: 165, name: "WEIGHING SCALE" },
    { id: 166, name: "WHEEL CHAIR ATTENDENT" },
    { id: 167, name: "WHEEL CHAIR PEDIATRIC" },
    { id: 168, name: "WHEEL CHAIR SELF DRIVEN" },
  ];

  const targetCategories = [
    { id: 2, name: "Respiratory Accessories" },
    { id: 3, name: "Paramonitor" },
    { id: 4, name: "Bed Sores Prevention Range" },
    { id: 5, name: "Oxygen Refilling" },
    { id: 6, name: "Oxygen Cylinder" },
    { id: 7, name: "Rehabilitation Product" },
    { id: 8, name: "Vascular Care" },
    { id: 9, name: "Foot Care Range" },
    { id: 10, name: "Oxygen Concentrator" },
    { id: 11, name: "Walker" },
    { id: 12, name: "Bi-PAP" },
    { id: 13, name: "C-PAP" },
    { id: 14, name: "Sleep Study" },
    { id: 15, name: "Mobility" },
    { id: 16, name: "Infection Control" },
    { id: 17, name: "Compression Garments" },
    { id: 18, name: "Recliners" },
    { id: 19, name: "Respiratory" },
    { id: 20, name: "Hospital Beds" },
    { id: 21, name: "Ventilator" },
    { id: 22, name: "Wheel Chairs" },
    { id: 23, name: "Braces / Splints" },
    { id: 24, name: "Nebulizer" },
    { id: 25, name: "Bathroom / Toilet Products" },
    { id: 26, name: "Pulse Oximeter" },
    { id: 27, name: "Suction Machine" },
    { id: 28, name: "Commode Chairs" },
    { id: 29, name: "Custom Made - Medanta" },
    { id: 30, name: "Pregnancy Care Range" },
    { id: 31, name: "Other Products" },
  ];

  const selectYesOrNo = [
    { id: 1, name: "Yes", code: "YES", description: "yes" },
    { id: 2, name: "No", code: "NO", description: "no" },
  ];
  const types = [
    { name: "MFG", code: "MFG", description: "MFG" },
    { name: "IMPORTED", code: "IMPORTED", description: "IMPORTED" },
    { name: "IMPORTEDX", code: "IMPORTEDX", description: "IMPORTEDX" },
    { name: "OTHER", code: "OTHER", description: "OTHER" },
  ];

  const brand = [
    { id: 1, name: "0" },
    { id: 2, name: "3M" },
    { id: 3, name: "ACER" },
    { id: 4, name: "ACTIVE" },
    { id: 5, name: "ACTIVE " },
    { id: 6, name: "ACTIVEAIR" },
    { id: 7, name: "AIG" },
    { id: 8, name: "AIR" },
    { id: 9, name: "AIR-O" },
    { id: 10, name: "AIRCAST" },
    { id: 11, name: "AIRSEP" },
    { id: 12, name: "AIRWAY" },
    { id: 13, name: "ANAND" },
    { id: 14, name: "ANAND INTERNATIONAL" },
    { id: 15, name: "ANGIO PRESS" },
    { id: 16, name: "ANTANO" },
    { id: 17, name: "ANTI" },
    { id: 18, name: "ANY" },
    { id: 19, name: "APEX" },
    { id: 20, name: "ARCUR" },
    { id: 21, name: "ARIETTE" },
    { id: 22, name: "ARJOHUNTLEIGH" },
    { id: 23, name: "ASTRA" },
    { id: 24, name: "ATTENDS" },
    { id: 25, name: "BABY" },
    { id: 26, name: "BARS" },
    { id: 27, name: "BECKCEM DRUG " },
    { id: 28, name: "BEE" },
    { id: 29, name: "BEEBO" },
    { id: 30, name: "BIONICS" },
    { id: 31, name: "BLUBOO" },
    { id: 32, name: "BMC" },
    { id: 33, name: "BODYGUARD" },
    { id: 34, name: "BOLT" },
    { id: 35, name: "BONNY" },
    { id: 36, name: "BOSTON" },
    { id: 37, name: "BREATHE-O" },
    { id: 38, name: "CERVICAL" },
    { id: 39, name: "CHOICEMED" },
    { id: 40, name: "CLEAR" },
    { id: 41, name: "CLEAR VIEW" },
    { id: 42, name: "COMFREY" },
    { id: 43, name: "COMFRY" },
    { id: 44, name: "COMMODE" },
    { id: 45, name: "CONSOLE" },
    { id: 46, name: "CONTAINER" },
    { id: 47, name: "COSCO" },
    { id: 48, name: "CPM" },
    { id: 49, name: "CSI ENTERPRISES" },
    { id: 50, name: "CUSTOM" },
    { id: 51, name: "DANTAL HYDRAULICS" },
    { id: 52, name: "DANTAL HYDRUALICS" },
    { id: 53, name: "DARCO" },
    { id: 54, name: "DESK MERCURY" },
    { id: 55, name: "DEVON" },
    { id: 56, name: "DIAL" },
    { id: 57, name: "DIGNITY" },
    { id: 58, name: "DJO" },
    { id: 59, name: "DONJOY" },
    { id: 60, name: "DOUBLE" },
    { id: 61, name: "DRIVE DEVILBISS" },
    { id: 62, name: "DUCK BACK" },
    { id: 63, name: "DUCK BUCK" },
    { id: 64, name: "EQINOX" },
    { id: 65, name: "EQUINOX" },
    { id: 66, name: "EXERCISE" },
    { id: 67, name: "EXPRESSIONS" },
    { id: 68, name: "EXPRETION ART" },
    { id: 69, name: "FERRULE" },
    { id: 70, name: "FIRST STEP PROJECTS" },
    { id: 71, name: "FISHER & PAYKEL" },
    { id: 72, name: "FITKING INNOVATIONS" },
    { id: 73, name: "FITNESS PRODUCT" },
    { id: 74, name: "FITNESS WORLD" },
    { id: 75, name: "FLAMINGO" },
    { id: 76, name: "FLEXIOH" },
    { id: 77, name: "FOLEE" },
    { id: 78, name: "FORZA" },
    { id: 79, name: "FRESENIUS" },
    { id: 80, name: "FRESH-O" },
    { id: 81, name: "FRIENDS" },
    { id: 82, name: "FRONT" },
    { id: 83, name: "FUTURO" },
    { id: 84, name: "GALEMED" },
    { id: 85, name: "GALEMED " },
    { id: 86, name: "GEL SMITH" },
    { id: 87, name: "GH-CARE" },
    { id: 88, name: "GINNI" },
    { id: 89, name: "GLENMARK" },
    { id: 90, name: "GOA" },
    { id: 91, name: "GONIOMETER" },
    { id: 92, name: "GURU" },
    { id: 93, name: "HAIER" },
    { id: 94, name: "HERNIA" },
    { id: 95, name: "HOCHSTE HEALTHCARE " },
    { id: 96, name: "HUMPTY EMPTY" },
    { id: 97, name: "HUNTLY" },
    { id: 98, name: "I-CARE" },
    { id: 99, name: "INDO SURGICALS" },
    { id: 100, name: "INFI" },
    { id: 101, name: "INOGEN" },
    { id: 102, name: "INSTAVAC" },
    { id: 103, name: "INVACARE" },
    { id: 104, name: "JAINSON" },
    { id: 105, name: "JERRY&TOM" },
    { id: 106, name: "KARMA" },
    { id: 107, name: "KENDALL" },
    { id: 108, name: "KERO" },
    { id: 109, name: "KLARITY MEDICAL" },
    { id: 110, name: "KOMFORT" },
    { id: 111, name: "KUMBRINK" },
    { id: 112, name: "L" },
    { id: 113, name: "LEFT" },
    { id: 114, name: "LITTLE" },
    { id: 115, name: "LIVO" },
    { id: 116, name: "LP" },
    { id: 117, name: "LUPINEB" },
    { id: 118, name: "LYMPHA" },
    { id: 119, name: "LYMPHA PRESS" },
    { id: 120, name: "MADE" },
    { id: 121, name: "MAX PLUSS" },
    { id: 122, name: "MEDELA" },
    { id: 123, name: "MEDICEVO" },
    { id: 124, name: "MEDIKIT" },
    { id: 125, name: "MEDIKONNECT" },
    { id: 126, name: "MEDIQUIP" },
    { id: 127, name: "MEDIRENT" },
    { id: 128, name: "MEDRENT" },
    { id: 129, name: "MEDVISION" },
    { id: 130, name: "MEE MEE" },
    { id: 131, name: "MEE MEE " },
    { id: 132, name: "MGRM" },
    { id: 133, name: "MIAMI" },
    { id: 134, name: "MINI" },
    { id: 135, name: "MIRROR" },
    { id: 136, name: "MONARCH" },
    { id: 137, name: "MY CARE" },
    { id: 138, name: "MY-CARE" },
    { id: 139, name: "NA" },
    { id: 140, name: "NAULAKHA " },
    { id: 141, name: "NAWLAKHA" },
    { id: 142, name: "NELLCORE" },
    { id: 143, name: "NIDAK" },
    { id: 144, name: "NIDEK" },
    { id: 145, name: "NORMA" },
    { id: 146, name: "NORTECH" },
    { id: 147, name: "OLEX" },
    { id: 148, name: "OMEGA" },
    { id: 149, name: "OMEGA CARE" },
    { id: 150, name: "OMRON" },
    { id: 151, name: "OPPO" },
    { id: 152, name: "ORTHOCURA" },
    { id: 153, name: "OSSUR" },
    { id: 154, name: "OSSURE" },
    { id: 155, name: "OXYGO" },
    { id: 156, name: "OXYKIT" },
    { id: 157, name: "OXYMED" },
    { id: 158, name: "OXYTECH" },
    { id: 159, name: "PAG" },
    { id: 160, name: "PARAMOOUNT" },
    { id: 161, name: "PARAMOUONT" },
    { id: 162, name: "PASHAN VENTURES" },
    { id: 163, name: "PEE" },
    { id: 164, name: "PEEBUDDY" },
    { id: 165, name: "PERAMOUNT" },
    { id: 166, name: "PHELBO PRESS" },
    { id: 167, name: "PHILIPS" },
    { id: 168, name: "PHILIPS RESPIRONICS" },
    { id: 169, name: "PHLEBO PRESS" },
    { id: 170, name: "PIERRE" },
    { id: 171, name: "PIONEER" },
    { id: 172, name: "PNEUMO CARE" },
    { id: 173, name: "POLYMED" },
    { id: 174, name: "PRAJWAL" },
    { id: 175, name: "PRECISION MEDIACL" },
    { id: 176, name: "RAINBOW" },
    { id: 177, name: "RAISER" },
    { id: 178, name: "RAXNEB" },
    { id: 179, name: "RE GENESIS" },
    { id: 180, name: "REBOTEC" },
    { id: 181, name: "REDCLIFFE" },
    { id: 182, name: "REMSON" },
    { id: 183, name: "RESMED" },
    { id: 184, name: "RESPIRONICS" },
    { id: 185, name: "ROMSONS" },
    { id: 186, name: "ROSSMAX" },
    { id: 187, name: "ROUND" },
    { id: 188, name: "SAI REHAB" },
    { id: 189, name: "SAI RIHAB" },
    { id: 190, name: "SANCTBAND" },
    { id: 191, name: "SANRAI" },
    { id: 192, name: "SCOOP" },
    { id: 193, name: "SES" },
    { id: 194, name: "SG HEALTH" },
    { id: 195, name: "SHARP" },
    { id: 196, name: "SHIELD" },
    { id: 197, name: "SILICONE" },
    { id: 198, name: "SIMPLY GO" },
    { id: 199, name: "SNOWBEAR BABY" },
    { id: 200, name: "SOCKS" },
    { id: 201, name: "SOT APPARELS " },
    { id: 202, name: "SS" },
    { id: 203, name: "STREIFENDER" },
    { id: 204, name: "STREIFENEDER" },
    { id: 205, name: "STREIFENEDER " },
    { id: 206, name: "SUNSET HEALTHCARE SOLUTION" },
    { id: 207, name: "SYNOCARE" },
    { id: 208, name: "TABORG" },
    { id: 209, name: "TAC" },
    { id: 210, name: "THERA" },
    { id: 211, name: "THERAPEARL" },
    { id: 212, name: "THERMA KOOL" },
    { id: 213, name: "THUMBSTER" },
    { id: 214, name: "TINY" },
    { id: 215, name: "TINYCARE" },
    { id: 216, name: "TRAVEL" },
    { id: 217, name: "TYCOON" },
    { id: 218, name: "TYNOR" },
    { id: 219, name: "UNI" },
    { id: 220, name: "UNI-EM" },
    { id: 221, name: "UNIROSS" },
    { id: 222, name: "UZMA" },
    { id: 223, name: "VELOCITY" },
    { id: 224, name: "VENANTE " },
    { id: 225, name: "VERMEIREN" },
    { id: 226, name: "VISCCO" },
    { id: 227, name: "VISION" },
    { id: 228, name: "VISSCO" },
    { id: 229, name: "WALL" },
    { id: 230, name: "WETEX" },
    { id: 231, name: "WHEELCHAIR" },
    { id: 232, name: "WONJIN PRODUCTS (KOREA)" },
    { id: 233, name: "XAMAX" },
    { id: 234, name: "YIFUBEIER" },
    { id: 235, name: "ZOY" },
  ];

  const productTypes = [
    { id: 1, name: "Rent", code: "RE", description: "Rent" },
    { id: 2, name: "Sale", code: "SL", description: "Sale" },
  ];
  const discarded = [
    { id: 1, name: "Not In Use", code: "NOU", description: "Not In Use" },
    { id: 1, name: "In Use", code: "IU", description: "In Use" },
  ];

  const selectedRowIdsRef = useRef(new Set());
  const selectedDataRef = useRef([]);
  const [hasSelection, setHasSelection] = useState(false);

  // eslint-disable-next-line
  const [validation, setValidation] = useState({});
  const [toggledClearRows, setToggledClearRows] = useState(false);

  // eslint-disable-next-line
  const [getErrorFields, setErrorFields] = useState([]);

  const [getShowFailureModal, setShowFailureModal] = useState();

  // eslint-disable-next-line
  const [disabled, setDisabled] = useState("");

  const [getShowFileViewModal, setShowFileViewModal] = useState(false);
  const [getFileViewData, setFileViewData] = useState(null);
  // eslint-disable-next-line
  const [fileDeleted, setFileDeleted] = useState(false);

  const [isCardVisible1, setCardVisible1] = useState(true);

  const [materialMode, setMaterialMode] = useState(true);

  const [loading, setLoading] = useState(false);

  // eslint-disable-next-line
  const [getDropdownData, setDropdownData] = useState("");
  const [getCompanyCode, setCompanyCode] = useState([]);

  const getMasterDataFunc = async () => {
    let obj = {
      queryName: "getSupplierList",
      module: "",
      page: pagination.page,
      per_page: pagination.per_page,
      timeZone: "Asia/Calcutta",
      rowFilter: {
        $and: [
          {
            "vendorCategory.vendorCategoryCode": "V04",
          },
        ],
      },
    };

    await ItemService.generateQuery(obj).then((item) => {
      if (item?.status === 200) {
        setData(item?.data);
        setTotalRows(item?.total || item?.data?.length || 0);
        // setDisabledStatus(true);
        // setFormInputs(item?.data[0]);
        // setItemTableData(item?.data[0].items);
      } else {
        setFormInputs([]);
        console.log(">> Error: Loading getQuotationDatail");
      }
    });

    let obj5 = {
      queryName: "Get_CompanyMaster_List",
      page: 1,
      per_page: 9999,
      searchTerm: "",
      timeZone: "Asia/Calcutta",
    };
    await ItemService.generateCustomerQuery(obj5).then((item) => {
      if (item?.status === 200) {
        setCompanyCode(item?.data);
      } else {
        setCompanyCode([]);
        console.log(">> Error: Loading getMasterData");
      }
    });

    let obj7 = {
      queryName: "getMaterilMasterList",
      page: 1,
      per_page: 99999,
    };

    // await ItemService.generateQuery(obj7).then((item) => {
    //   if (item?.status === 200) {
    //     setaccessoriesCode(item?.data);
    //   } else {
    //     setFormInputs([]);
    //     console.log(">> Error: Loading getQuotationDatail");
    //   }
    // });
    await ItemService.generateQuery(obj7).then((item) => {
      if (item?.status === 200) {
        const mapped = item?.data?.map((m) => ({
          materialCode: m.materialCode,
          materialDescription: m.materialDescription,
          label: `${m.materialCode} - ${m.materialDescription}`,
        }));
        setaccessoriesCode(mapped);
      } else {
        setaccessoriesCode([]);
        console.log(">> Error: Loading getMaterilMasterList");
      }
    });
  };

  useEffect(() => {
    if (props?.show === "CREATE") {
      setMaterialMode(false);
    } else if (props?.show === "EDIT") {
      setMaterialMode(false);
    } else if (props?.show === "DETAILS") {
      setMaterialMode(true);
    } else {
      setMaterialMode(true);
    }
  }, [props?.show]);

  const [getCommonSearchTxt, setCommonSearchTxt] = useState("");

  const toggleCardVisibility1 = () => {
    setCardVisible1(!isCardVisible1);
  };

  const hideFailureModal = () => {
    setShowFailureModal(false);
  };

  useEffect(() => {
    if (props?.show === "CREATE") {
      setFormInputs({
        materialAttachments: "",
        materialImage: "",
        materialCode: "",
        materialDescription: "",
        materialGroup: "",
        average: "",
        quntity: "",
        pieceMeasure: "",
        unit: "",
        unitWeight: "",
        unitPrice: "",
        unitWeightModifier: "",
        unitPriceModifier: "",
        surfacePaintArea: "",
        remarks: "",
        weightPice: "",
        weightTotal: "",
        bookPrice: "",
        bookTotalPrice: "",
      });
    }
  }, [props?.show]);

  useEffect(() => {
    const handleEscapeKey = (event) => {
      if (event.key === "Escape" || event.keyCode === 27) {
        props.onHide();
      }
    };
    document.addEventListener("keydown", handleEscapeKey);
    return () => {
      document.removeEventListener("keydown", handleEscapeKey);
    };
  }, [props]);

  const numberFields = [
    "salePrice",
    "rentPerDayPrice",
    "rent7DaysPrice",
    "rent15DaysPrice",
    "rent30DaysPrice",
    "purchaseQuantity",
    "unitPrice",
    "mrPrice",
    "taxCode",
    "cog",
    "securityAmt",
    "lockInPeriod",
  ];
  const [data, setData] = useState([]);
  // eslint-disable-next-line
  const [getSelectedData, setSelectedData] = useState([]);
  const [hospital, setHospitalData] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [pagination, setPagination] = useState({
    page: 1,
    per_page: 10,
  });

  // const onInputChange = ({ target: { name, value } }) => {
  //   const errors = {};
  //   setFormInputs((prev) => ({
  //     ...prev,
  //     [name]: numberFields.includes(name)
  //       ? value === ""
  //         ? ""
  //         : Number(value)
  //       : value,
  //   }));
  //   setValidation((prev) => ({
  //     ...prev,
  //     [name]: errors[name] || "",
  //   }));
  // };

  const onInputChange = ({ target: { name, value } }) => {
  const errors = {};
  setFormInputs((prev) => ({
    ...prev,
    [name]: numberFields.includes(name)
      ? value === ""
        ? ""
        : Number(value)
      : value,
    // keep the PO-facing mirror in sync with the master field
    ...(name === "unitPrice"
      ? { orderPriceUnit: value === "" ? "" : Number(value) }
      : {}),
  }));
  setValidation((prev) => ({
    ...prev,
    [name]: errors[name] || "",
  }));
};

  useEffect(() => {
    if ((props?.show === "EDIT" || props?.show === "DETAILS") && materialNr) {
      setLoading(true); // start loading
      let obj = {
        queryName: "Get_MATERIAL_DETAIL",
        documentNumber: materialNr,
      };
      ItemService.generateCustomerQuery(obj)
        .then((res) => {
          if (res?.data?.length) {
            setFormInputs(res.data[0]);
          }
        })
        .catch(() => {
          toast.error("Failed to fetch material details!");
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [props?.show, materialNr]);

  const handleSubmit = async () => {
    let requiredFields = [];
    const anyFieldNotEmpty = Object.values(validation).some(
      (value) => value !== null && value !== "",
    );
    if (anyFieldNotEmpty) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureModal(true);
      return;
    }
    if (!validateRequired(formInputs.companyCode)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureModal(true);
      setValidation((prev) => ({
        ...prev,
        companyCode: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }
    if (!validateRequired(formInputs.materialCode)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureModal(true);
      setValidation((prev) => ({
        ...prev,
        materialCode: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }
    if (!validateRequired(formInputs.materialGroup)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureModal(true);
      setValidation((prev) => ({
        ...prev,
        materialGroup: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }
    if (!validateRequired(formInputs.materialSubCategory)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureModal(true);
      setValidation((prev) => ({
        ...prev,
        materialSubCategory: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }
    if (!validateRequired(formInputs.materialDescription)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureModal(true);
      setValidation((prev) => ({
        ...prev,
        materialDescription: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }
    if (!validateRequired(formInputs.hsnCode)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureModal(true);
      setValidation((prev) => ({
        ...prev,
        hsnCode: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }
    // if (!validateRequired(formInputs.purchaseQuantity)) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     purchaseQuantity: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }
    // if (!validateRequired(formInputs.purchaseQuantity)) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     purchaseQuantity: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }
    if (!validateRequired(formInputs.unit)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureModal(true);
      setValidation((prev) => ({
        ...prev,
        unit: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }
    if (!validateRequired(formInputs.unitPrice)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureModal(true);
      setValidation((prev) => ({
        ...prev,
        unitPrice: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }
    if (!validateRequired(formInputs.mrPrice)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureModal(true);
      setValidation((prev) => ({
        ...prev,
        mrPrice: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }
    if (!validateRequired(formInputs.taxCode)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureModal(true);
      setValidation((prev) => ({
        ...prev,
        taxCode: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }
    if (!validateRequired(formInputs.cog)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureModal(true);
      setValidation((prev) => ({
        ...prev,
        cog: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }
    if (!validateRequired(formInputs.salePrice)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureModal(true);
      setValidation((prev) => ({
        ...prev,
        salePrice: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }
    if (!validateRequired(formInputs.rentPerDayPrice)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureModal(true);
      setValidation((prev) => ({
        ...prev,
        rentPerDayPrice: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }
    if (!validateRequired(formInputs.rent7DaysPrice)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureModal(true);
      setValidation((prev) => ({
        ...prev,
        rent7DaysPrice: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }
    if (!validateRequired(formInputs.rent15DaysPrice)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureModal(true);
      setValidation((prev) => ({
        ...prev,
        rent15DaysPrice: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }
    if (!validateRequired(formInputs.rent30DaysPrice)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureModal(true);
      setValidation((prev) => ({
        ...prev,
        rent30DaysPrice: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }

    //-------------------------------------------

    const cleanAccessories = (formInputs?.accessoriesCode || []).map((a) => ({
      materialCode: a.materialCode,
      materialDescription: a.materialDescription,
    }));
    const cleanHospital = hospital.flat().map((h) => ({
      _id: h._id,
      hospitalName: h.hospitalName,
      hosptalCode: h.hosptalCode || h.customerCode,
      customerCode: h.customerCode,
      rentPerDayPrice: Number(h.rentPerDayPrice ?? 0),
      rent7DaysPrice: Number(h.rent7DaysPrice ?? 0),
      rent15DaysPrice: Number(h.rent15DaysPrice ?? 0),
      rent30DaysPrice: Number(h.rent30DaysPrice ?? 0),
      unitPrice: Number(h.unitPrice ?? 0),
      mrPrice: Number(h.mrPrice ?? 0),
      taxCode: Number(h.taxCode ?? 0),
      cog: Number(h.cog ?? 0),
      salePrice: Number(h.salePrice ?? 0),
    }));
    // let obj = {
    //   data: {
    //     ...formInputs,
    //     orderPriceUnit: parseFloat(formInputs?.unitPrice),
    //     orderUnitOfMeasure: formInputs?.unit,
    //     uOM: formInputs?.unit,
    //     hospital: hospital,
    //   },
    // };
    let obj = {
      data: {
        ...formInputs,
        orderPriceUnit: parseFloat(formInputs?.unitPrice),
        orderUnitOfMeasure: formInputs?.unit,
        uOM: formInputs?.unit,
        accessoriesCode: cleanAccessories,
        hospital: cleanHospital,
      },
    };

    setDisabled(true);
    await ItemService.addMaterial(obj).then((item) => {
      if (item?.status === 200) {
        toast.success(item?.message || "Material Added successfully", {
          duration: 2000,
          position: "top-right",
        });
        props.onHide();

        setFormInputs({
          materialAttachments: "",
          materialImage: "",
          materialCode: "",
          materialDescription: "",
          materialGroup: "",
          average: "",
          quntity: "",
          pieceMeasure: "",
          unit: "",
          unitWeight: "",
          unitPrice: "",
          unitWeightModifier: "",
          unitPriceModifier: "",
          surfacePaintArea: "",
          remarks: "",
          weightPice: "",
          weightTotal: "",
          bookPrice: "",
          bookTotalPrice: "",
        });

        let obj = {
          queryName: "getMaterilMasterList",
          page: 1,
          per_page: 10,
        };
        dispatch(getMaterialList(obj));
      } else {
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
        // setErrorMsg("*" + item?.message);
      }
      setDisabled(false);
    });
    toast.dismiss("");
  };

  // const handleUpdate = async () => {
  //   const { _id, ...rest } = formInputs;

  //   // Build dirty-only payload by comparing against the initial snapshot
  //   const initial = initialFormInputsRef.current || {};
  //   const changedFields = Object.keys(rest).reduce((acc, key) => {
  //     const curr = rest[key];
  //     const orig = initial[key];
  //     const isChanged =
  //       JSON.stringify(curr ?? "") !== JSON.stringify(orig ?? "");
  //     if (isChanged) acc[key] = curr;
  //     return acc;
  //   }, {});

  //   if (
  //     Object.keys(changedFields).length === 0 &&
  //     hospital === (initial.hospital || [])
  //   ) {
  //     toast("No changes to save.", { duration: 2000, position: "top-right" });
  //     return;
  //   }

  //   const cleanAccessories = (formInputs?.accessoriesCode || []).map((a) => ({
  //     materialCode: a.materialCode,
  //     materialDescription: a.materialDescription,
  //   }));
  //   const cleanHospital = hospital.flat().map((h) => ({
  //     _id: h._id,
  //     hospitalName: h.hospitalName || h.organisationName,
  //     hosptalCode: h.hosptalCode || h.customerCode,
  //     customerCode: h.customerCode,
  //     rentPerDayPrice: Number(h.rentPerDayPrice ?? 0),
  //     rent7DaysPrice: Number(h.rent7DaysPrice ?? 0),
  //     rent15DaysPrice: Number(h.rent15DaysPrice ?? 0),
  //     rent30DaysPrice: Number(h.rent30DaysPrice ?? 0),
  //     unitPrice: Number(h.unitPrice ?? 0),
  //     mrPrice: Number(h.mrPrice ?? 0),
  //     taxCode: Number(h.taxCode ?? 0),
  //     cog: Number(h.cog ?? 0),
  //     salePrice: Number(h.salePrice ?? 0),
  //   }));

  //   // Create the base update object
  //   const updateObj = {
  //     ...changedFields,
  //     materialCode: formInputs?.materialCode,
  //     accessoriesCode: cleanAccessories,
  //     hospital: cleanHospital,
  //     timeZone: "Asia/Calcutta",
  //   };

  //   // Create barcodeDetails with the same fields
  //   const obj = {
  //     ...updateObj,
  //     barcodeDetails: { ...updateObj },
  //   };

  //   // console.log(">>obj", obj);

  //   setDisabled(true);
  //   await ItemService.updateMaterial(obj).then((item) => {
  //     if (item?.status === 200) {
  //       toast.success(item?.message || "Updated successfully", {
  //         duration: 2000,
  //         position: "top-right",
  //       });
  //       props.onHide();
  //       setFormInputs({
  //         materialAttachments: "",
  //         materialImage: "",
  //         materialCode: "",
  //         materialDescription: "",
  //         materialGroup: "",
  //         average: "",
  //         quntity: "",
  //         pieceMeasure: "",
  //         unit: "",
  //         unitWeight: "",
  //         unitPrice: "",
  //         unitWeightModifier: "",
  //         unitPriceModifier: "",
  //         surfacePaintArea: "",
  //         remarks: "",
  //         weightPice: "",
  //         weightTotal: "",
  //         bookPrice: "",
  //         bookTotalPrice: "",
  //         accessories: false,
  //         accessoriesCode: [],
  //       });
  //       initialFormInputsRef.current = null;
  //       let obj = {
  //         queryName: "getMaterilMasterList",
  //         page: 1,
  //         per_page: 10,
  //       };
  //       dispatch(getMaterialList(obj));
  //     } else {
  //       toast.error(item?.message || "Please try again !!", {
  //         duration: 4000,
  //         position: "top-right",
  //       });
  //     }
  //     setDisabled(false);
  //   });
  //   // toast.dismiss("");
  // };

  const handleUpdate = async () => {
    // const { _id, ...rest } = formInputs;

    // // Build dirty-only payload by comparing against the initial snapshot
    // const initial = initialFormInputsRef.current || {};
    // const changedFields = Object.keys(rest).reduce((acc, key) => {
    //   const curr = rest[key];
    //   const orig = initial[key];
    //   const isChanged =
    //     JSON.stringify(curr ?? "") !== JSON.stringify(orig ?? "");
    //   if (isChanged) acc[key] = curr;
    //   return acc;
    // }, {});

    // if (
    //   Object.keys(changedFields).length === 0 &&
    //   hospital === (initial.hospital || [])
    // ) {
    //   toast("No changes to save.", { duration: 2000, position: "top-right" });
    //   return;
    // }

    // const cleanAccessories = (formInputs?.accessoriesCode || []).map((a) => ({
    //   materialCode: a.materialCode,
    //   materialDescription: a.materialDescription,
    // }));
    // const cleanHospital = hospital.flat().map((h) => ({
    //   _id: h._id,
    //   hospitalName: h.hospitalName || h.organisationName,
    //   hosptalCode: h.hosptalCode || h.customerCode,
    //   customerCode: h.customerCode,
    //   rentPerDayPrice: Number(h.rentPerDayPrice ?? 0),
    //   rent7DaysPrice: Number(h.rent7DaysPrice ?? 0),
    //   rent15DaysPrice: Number(h.rent15DaysPrice ?? 0),
    //   rent30DaysPrice: Number(h.rent30DaysPrice ?? 0),
    //   unitPrice: Number(h.unitPrice ?? 0),
    //   mrPrice: Number(h.mrPrice ?? 0),
    //   taxCode: Number(h.taxCode ?? 0),
    //   cog: Number(h.cog ?? 0),
    //   salePrice: Number(h.salePrice ?? 0),
    // }));

    // // Create the base update object
    // const updateObj = {
    //   ...changedFields,
    //   materialCode: formInputs?.materialCode,
    //   accessoriesCode: cleanAccessories,
    //   hospital: cleanHospital,
    //   timeZone: "Asia/Calcutta",
    // };

    // // Create barcodeDetails with the same fields
    // const obj = {
    //   ...updateObj,
    //   barcodeDetails: { ...updateObj },
    // };
    const { _id, ...rest } = formInputs;

    // Build dirty-only payload by comparing against the initial snapshot
    const initial = initialFormInputsRef.current || {};
    const changedFields = Object.keys(rest).reduce((acc, key) => {
      const curr = rest[key];
      const orig = initial[key];
      const isChanged =
        JSON.stringify(curr ?? "") !== JSON.stringify(orig ?? "");
      if (isChanged) acc[key] = curr;
      return acc;
    }, {});

    if (
      Object.keys(changedFields).length === 0 &&
      JSON.stringify(hospital) === JSON.stringify(initial.hospital || [])
    ) {
      toast("No changes to save.", { duration: 2000, position: "top-right" });
      return;
    }

    const cleanAccessories = (formInputs?.accessoriesCode || []).map((a) => ({
      materialCode: a.materialCode,
      materialDescription: a.materialDescription,
    }));

    const cleanHospital = hospital.flat().map((h) => ({
      _id: h._id,
      hospitalName: h.hospitalName || h.organisationName,
      hosptalCode: h.hosptalCode || h.customerCode,
      customerCode: h.customerCode,
      rentPerDayPrice: Number(h.rentPerDayPrice ?? 0),
      rent7DaysPrice: Number(h.rent7DaysPrice ?? 0),
      rent15DaysPrice: Number(h.rent15DaysPrice ?? 0),
      rent30DaysPrice: Number(h.rent30DaysPrice ?? 0),
      unitPrice: Number(h.unitPrice ?? 0),
      mrPrice: Number(h.mrPrice ?? 0),
      taxCode: Number(h.taxCode ?? 0),
      cog: Number(h.cog ?? 0),
      salePrice: Number(h.salePrice ?? 0),
    }));

    // Create complete object by spreading formInputs and adding computed fields
    const completeObject = {
      ...formInputs, // This includes ALL form fields
      orderPriceUnit: parseFloat(formInputs?.unitPrice) || 0,
      accessoriesCode: cleanAccessories,
      hospital: cleanHospital,
      timeZone: "Asia/Calcutta",
    };

    // Remove _id if it exists
    delete completeObject._id;

    // Create the final object
    const obj = {
      ...changedFields, // Only changed fields for main update (optional)
      orderPriceUnit: parseFloat(formInputs?.unitPrice) || 0,
      materialCode: formInputs?.materialCode,
      accessoriesCode: cleanAccessories,
      hospital: cleanHospital,
      timeZone: "Asia/Calcutta",
      barcodeDetails: { ...completeObject }, // Complete object with ALL fields
    };

    setDisabled(true);
    await ItemService.updateMaterial(obj).then((item) => {
      if (item?.status === 200) {
        toast.success(item?.message || "Updated successfully", {
          duration: 2000,
          position: "top-right",
        });
        props.onHide();
        setFormInputs({
          materialAttachments: "",
          materialImage: "",
          materialCode: "",
          materialDescription: "",
          materialGroup: "",
          average: "",
          quntity: "",
          pieceMeasure: "",
          unit: "",
          unitWeight: "",
          unitPrice: "",
          unitWeightModifier: "",
          unitPriceModifier: "",
          surfacePaintArea: "",
          remarks: "",
          weightPice: "",
          weightTotal: "",
          bookPrice: "",
          bookTotalPrice: "",
          accessories: false,
          accessoriesCode: [],
        });
        initialFormInputsRef.current = null;
        let obj = {
          queryName: "getMaterilMasterList",
          page: 1,
          per_page: 10,
        };
        dispatch(getMaterialList(obj));
      } else {
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
      setDisabled(false);
    });
    // toast.dismiss("");
  };
  const onSuccessUploadDocumentType = (data) => {
    const value = data.attachmentId || data.id;
    setFormInputs((formInputs) => ({
      ...formInputs,
      [data.fieldName]: value,
    }));
  };

  const handleViewFile = (fileAttachmentId) => {
    setFileViewData(fileAttachmentId);
    setShowFileViewModal(true);
  };
  const handleViewFileHide = () => {
    setShowFileViewModal(false);
  };

  useEffect(() => {
    if (getDropdownData?.textField === "materialGroup") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        materialGroup: getDropdownData?.name,
        materialGroupCode: getDropdownData?.code,
        materialGroupDesc: getDropdownData?.description,
      }));
    } else if (getDropdownData?.textField === "unit") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.textCode,
        [getDropdownData?.textDesc]: getDropdownData?.textDesc,
      }));
    } else if (getDropdownData?.textField === "type") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.textCode,
        [getDropdownData?.textDesc]: getDropdownData?.textDesc,
      }));
    } else if (getDropdownData?.textField === "storageLocation") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.textCode,
        [getDropdownData?.textDesc]: getDropdownData?.textDesc,
      }));
    } else if (getDropdownData?.textField === "companyCode") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.companyCode,
        [getDropdownData?.textCode]: getDropdownData?.companyCodeCode,
        [getDropdownData?.textDesc]: getDropdownData?.companyCodeDesc,
      }));
    } else if (getDropdownData?.textField === "category") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
      }));
    } else if (getDropdownData?.textField === "category") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
      }));
    } else if (getDropdownData?.textField === "subCategory") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
      }));
    } else if (getDropdownData?.textField === "targetCategory") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
      }));
    } else if (getDropdownData?.textField === "materialSubCategory") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
      }));
    } else if (getDropdownData?.textField === "criticalProduct") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
      }));
    } else if (getDropdownData?.textField === "brand") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
      }));
    } else if (getDropdownData?.textField === "discarded") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
      }));
    } else if (getDropdownData?.textField === "topSelling") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
      }));
    } else if (getDropdownData?.textField === "type") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
      }));
    } else if (getDropdownData?.textField === "importedBy") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
      }));
    } else if (getDropdownData?.textField === "mfgBy") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
      }));
    } else if (getDropdownData?.textField === "mktBy") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
      }));
    } else if (getDropdownData?.textField === "mrpStatus") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
      }));
    }
    setValidation((prev) => ({
      ...prev,
      [getDropdownData?.textField]: "",
    }));
  }, [getDropdownData]);

  // AFTER
  useEffect(() => {
    if (props?.data) {
      // Normalize saved accessoriesCode: keep only entries that exist in master list
      const savedCodes = props.data?.accessoriesCode || [];
      const normalizedCodes = savedCodes
        .map((saved) => {
          const code = typeof saved === "string" ? saved : saved?.materialCode;
          return accessoriesCode?.find((item) => item.materialCode === code);
        })
        .filter(Boolean);

      const merged = {
        ...props.data,
        purchaseQuantity: props.data?.purchaseQuantity ?? 1,
        accessories: props.data?.accessories || false,
        accessoriesCode: normalizedCodes,
      };

      setFormInputs((prev) => ({ ...prev, ...merged }));
      initialFormInputsRef.current = merged;
      setHospitalData(props?.data?.hospital || []);
    }
    getMasterDataFunc();
    // eslint-disable-next-line
  }, [props]);

  // Fetch data when pagination changes
  useEffect(() => {
    if (props?.show && pagination.page) {
      let obj = {
        queryName: "getSupplierList",
        module: "",
        page: pagination.page,
        per_page: pagination.per_page,
        timeZone: "Asia/Calcutta",
        rowFilter: {
          $and: [
            {
              "vendorCategory.vendorCategoryCode": "V04",
            },
          ],
        },
      };

      ItemService.generateQuery(obj).then((item) => {
        if (item?.status === 200) {
          setData(item?.data);
          setTotalRows(item?.total || item?.data?.length || 0);
        }
      });
    }
    // eslint-disable-next-line
  }, [pagination.page, pagination.per_page]);

  const handleInputRowChange = (id, event) => {
    const { name, value } = event.target;

    setData((prevData) =>
      prevData.map((row) => (row._id === id ? { ...row, [name]: value } : row)),
    );
  };
  const handleCheckBoxChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormInputs((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleMultiChange = (index, name, value) => {
    setFormInputs((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // const columns = [
  //   {
  //     name: "Hospital",
  //     selector: (row) => row?.hospitalName,
  //     cell: (row) => (
  //       <div>
  //         <p className="m-0 p-0 fw-medium text-black">{row?.hospitalName}</p>
  //         <p className="m-0 p-0 pt-1">{row?.customerCode}</p>
  //       </div>
  //     ),
  //     sortable: true,
  //     width: "120px",
  //   },
  //   {
  //     name: "Rent Per Day",
  //     cell: (row) => (
  //       <InputField
  //         className="inputBox mt-1"
  //         name="rentPerDayPrice"
  //         value={row.rentPerDayPrice || ""}
  //         onChange={(event) => handleInputRowChange(row._id, event)}
  //         disabled={materialMode || !selectedRowIdsRef.current.has(row._id)}
  //       />
  //     ),
  //     width: "160px",
  //   },
  //   {
  //     name: "Rent Per 7 day",
  //     cell: (row) => (
  //       <InputField
  //         className="inputBox mt-1"
  //         name="rent7DaysPrice"
  //         value={row.rent7DaysPrice || ""}
  //         onChange={(event) => handleInputRowChange(row._id, event)}
  //         disabled={materialMode || !selectedRowIdsRef.current.has(row._id)}
  //       />
  //     ),
  //     width: "160px",
  //   },
  //   {
  //     name: "Rent Per 15 day",
  //     cell: (row) => (
  //       <InputField
  //         className="inputBox mt-1"
  //         name="rent15DaysPrice"
  //         value={row.rent15DaysPrice || ""}
  //         onChange={(event) => handleInputRowChange(row._id, event)}
  //         disabled={materialMode || !selectedRowIdsRef.current.has(row._id)}
  //       />
  //     ),
  //     width: "160px",
  //   },
  //   {
  //     name: "Rent Per 30 day",
  //     cell: (row) => (
  //       <InputField
  //         className="inputBox mt-1"
  //         name="rent30DaysPrice"
  //         value={row.rent30DaysPrice || ""}
  //         onChange={(event) => handleInputRowChange(row._id, event)}
  //         disabled={materialMode || !selectedRowIdsRef.current.has(row._id)}
  //       />
  //     ),
  //     width: "160px",
  //   },
  //   {
  //     name: "Vendor Rate (Unit Price)",
  //     cell: (row) => (
  //       <InputField
  //         className="inputBox mt-1"
  //         name="unitPrice"
  //         value={row.unitPrice || ""}
  //         onChange={(event) => handleInputRowChange(row._id, event)}
  //         disabled={materialMode || !selectedRowIdsRef.current.has(row._id)}
  //       />
  //     ),
  //     width: "160px",
  //   },
  //   {
  //     name: "MR Price",
  //     cell: (row) => (
  //       <InputField
  //         className="inputBox mt-1"
  //         name="mrPrice"
  //         value={row.mrPrice || ""}
  //         onChange={(event) => handleInputRowChange(row._id, event)}
  //         disabled={materialMode || !selectedRowIdsRef.current.has(row._id)}
  //       />
  //     ),
  //     width: "160px",
  //   },
  //   {
  //     name: "GST",
  //     cell: (row) => (
  //       <InputField
  //         className="inputBox mt-1"
  //         name="taxCode"
  //         value={row.taxCode || ""}
  //         onChange={(event) => handleInputRowChange(row._id, event)}
  //         disabled={materialMode || !selectedRowIdsRef.current.has(row._id)}
  //       />
  //     ),
  //     width: "160px",
  //   },
  //   {
  //     name: "COG",
  //     cell: (row) => (
  //       <InputField
  //         className="inputBox mt-1"
  //         name="cog"
  //         value={row.cog || ""}
  //         onChange={(event) => handleInputRowChange(row._id, event)}
  //         disabled={materialMode || !selectedRowIdsRef.current.has(row._id)}
  //       />
  //     ),
  //     width: "160px",
  //   },
  //   {
  //     name: "Sale Price",
  //     cell: (row) => (
  //       <InputField
  //         className="inputBox mt-1"
  //         name="salePrice"
  //         value={row.salePrice || ""}
  //         onChange={(event) => handleInputRowChange(row._id, event)}
  //         disabled={materialMode || !selectedRowIdsRef.current.has(row._id)}
  //       />
  //     ),
  //     width: "160px",
  //   },
  // ];

  const columns = [
    {
      name: "Hospital",
      selector: (row) => row?.hospitalName,
      cell: (row) => (
        <div>
          <p className="m-0 p-0 fw-medium text-black">{row?.hospitalName}</p>
          <p className="m-0 p-0 pt-1">{row?.customerCode}</p>
        </div>
      ),
      sortable: true,
      width: "120px",
    },
    {
      name: "Rent Per Day",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="rentPerDayPrice"
          value={row.rentPerDayPrice || ""}
          onChange={(event) => handleInputRowChange(row._id, event)}
          disabled={materialMode || !selectedRowIdsRef.current.has(row._id)}
        />
      ),
      width: "160px",
    },
    {
      name: "Rent Per 7 day",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="rent7DaysPrice"
          value={row.rent7DaysPrice || ""}
          onChange={(event) => handleInputRowChange(row._id, event)}
          disabled={materialMode || !selectedRowIdsRef.current.has(row._id)}
        />
      ),
      width: "160px",
    },
    {
      name: "Rent Per 15 day",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="rent15DaysPrice"
          value={row.rent15DaysPrice || ""}
          onChange={(event) => handleInputRowChange(row._id, event)}
          disabled={materialMode || !selectedRowIdsRef.current.has(row._id)}
        />
      ),
      width: "160px",
    },
    {
      name: "Rent Per 30 day",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="rent30DaysPrice"
          value={row.rent30DaysPrice || ""}
          onChange={(event) => handleInputRowChange(row._id, event)}
          disabled={materialMode || !selectedRowIdsRef.current.has(row._id)}
        />
      ),
      width: "160px",
    },
    {
      name: "Vendor Rate (Unit Price)",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="unitPrice"
          value={row.unitPrice || ""}
          onChange={(event) => handleInputRowChange(row._id, event)}
          disabled={materialMode || !selectedRowIdsRef.current.has(row._id)}
        />
      ),
      width: "160px",
    },
    {
      name: "MR Price",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="mrPrice"
          value={row.mrPrice || ""}
          onChange={(event) => handleInputRowChange(row._id, event)}
          disabled={materialMode || !selectedRowIdsRef.current.has(row._id)}
        />
      ),
      width: "160px",
    },
    {
      name: "GST",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="taxCode"
          value={row.taxCode || ""}
          onChange={(event) => handleInputRowChange(row._id, event)}
          disabled={materialMode || !selectedRowIdsRef.current.has(row._id)}
        />
      ),
      width: "160px",
    },
    {
      name: "COG",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="cog"
          value={row.cog || ""}
          onChange={(event) => handleInputRowChange(row._id, event)}
          disabled={materialMode || !selectedRowIdsRef.current.has(row._id)}
        />
      ),
      width: "160px",
    },
    {
      name: "Sale Price",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="salePrice"
          value={row.salePrice || ""}
          onChange={(event) => handleInputRowChange(row._id, event)}
          disabled={materialMode || !selectedRowIdsRef.current.has(row._id)}
        />
      ),
      width: "160px",
    },
  ];
  const hospitalColumns = [
    {
      name: "Hospital",
      selector: (row) => row?.hospitalName,
      cell: (row) => (
        <div>
          <p className="m-0 p-0  fw-medium text-black">{row?.hospitalName} </p>
          <p className="m-0 p-0 pt-1  ">{row?.customerCode} </p>
        </div>
      ),
      sortable: true,
      width: "120px",
    },

    {
      name: "Rent Per Day",
      selector: (row) => row?.rentPerDayPrice,
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="rentPerDayPrice"
          placeholder=""
          value={row.rentPerDayPrice || ""}
          onChange={(event) => handleInputRowChange(row._id, event)}
          disabled={true}
        />
      ),
      width: "160px",
    },
    {
      name: "Rent Per 7 day",
      selector: (row) => row?.rent7DaysPrice,
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="rent7DaysPrice"
          placeholder=""
          value={row.rent7DaysPrice || ""}
          onChange={(event) => handleInputRowChange(row._id, event)}
          disabled={true}
        />
      ),
      width: "160px",
    },
    {
      name: "Rent Per 15 day",
      selector: (row) => row?.rent15DaysPrice,
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="rent15DaysPrice"
          placeholder=""
          value={row.rent15DaysPrice || ""}
          onChange={(event) => handleInputRowChange(row._id, event)}
          disabled={true}
        />
      ),
      width: "160px",
    },
    {
      name: "Rent Per 30 day",
      selector: (row) => row?.rent30DaysPrice,
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="rent30DaysPrice"
          placeholder=""
          value={row.rent30DaysPrice || ""}
          onChange={(event) => handleInputRowChange(row._id, event)}
          disabled={true}
        />
      ),
      width: "160px",
    },
    {
      name: "Vendor Rate (Unit Price)",
      selector: (row) => row?.unitPrice,
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="unitPrice"
          value={row.unitPrice || ""}
          onChange={(event) => handleInputRowChange(row._id, event)}
          disabled={true}
        />
      ),
      width: "160px",
    },
    {
      name: "MR Price",
      selector: (row) => row?.mrPrice,
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="mrPrice"
          value={row.mrPrice || ""}
          onChange={(event) => handleInputRowChange(row._id, event)}
          disabled={true}
        />
      ),
      width: "160px",
    },
    {
      name: "GST",
      selector: (row) => row?.taxCode,
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="taxCode"
          value={row.taxCode || ""}
          onChange={(event) => handleInputRowChange(row._id, event)}
          disabled={true}
        />
      ),
      width: "160px",
    },
    {
      name: "COG",
      selector: (row) => row?.cog,
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="cog"
          value={row.cog || ""}
          onChange={(event) => handleInputRowChange(row._id, event)}
          disabled={true}
        />
      ),
      width: "160px",
    },
    {
      name: "Sale Price",
      selector: (row) => row?.salePrice,
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="salePrice"
          value={row.salePrice || ""}
          onChange={(event) => handleInputRowChange(row._id, event)}
          disabled={true}
        />
      ),
      width: "160px",
    },

    {
      name: "Action",
      cell: (row) => (
        <button
          className="btn btn-danger"
          onClick={() => deleteHospital(row._id)}
        >
          <i class="bi bi-trash3 mx-2"></i>
          Delete
        </button>
      ),
      width: "160px",
    },
  ];
  const handleSearchFuncApi = async () => {
    // Reset to page 1 when searching
    setPagination((prev) => ({ ...prev, page: 1 }));

    let obj = {
      queryName: "getSupplierList",
      module: "",
      page: 1,
      per_page: pagination.per_page,
      timeZone: "Asia/Calcutta",
      rowFilter: {
        $and: [
          {
            "vendorCategory.vendorCategoryCode": "V04",
          },
          {
            $or: [
              {
                organisationName: {
                  $regex: `.*${getCommonSearchTxt || ""}.*`,
                  $options: "i",
                },
              },
              {
                customerCode: {
                  $regex: `.*${getCommonSearchTxt || ""}.*`,
                  $options: "i",
                },
              },
            ],
          },
        ],
      },
    };

    await ItemService.generateQuery(obj).then((item) => {
      if (item?.status === 200) {
        setData(item?.data);
        setTotalRows(item?.total || item?.data?.length || 0);
      }
    });
  };

  const handlePageChange = (page) => {
    setPagination((prev) => ({ ...prev, page }));
  };

  const handlePerRowsChange = (newPerPage, page) => {
    setPagination((prev) => ({ ...prev, per_page: newPerPage, page }));
  };

  // const handleChangeCat = useCallback(({ selectedRows }) => {
  //   const uniqueRows = [];
  //   const seen = new Set();

  //   selectedRows.forEach((item) => {
  //     if (!seen.has(item._id)) {
  //       seen.add(item._id);
  //       uniqueRows.push(item);
  //     }
  //   });

  //   const newSelectedIds = new Set(uniqueRows.map((r) => r._id));
  //   selectedRowIdsRef.current = newSelectedIds;
  //   setSelectedData(uniqueRows);
  //   setSelectedRowIds(new Set(newSelectedIds));
  // }, []);

  const handleChangeCat = useCallback(({ selectedRows }) => {
    const uniqueRows = [];
    const seen = new Set();
    selectedRows.forEach((item) => {
      if (!seen.has(item._id)) {
        seen.add(item._id);
        uniqueRows.push(item);
      }
    });
    // Store in refs only - no state update = no re-render
    selectedRowIdsRef.current = new Set(uniqueRows.map((r) => r._id));
    selectedDataRef.current = uniqueRows;
    // Only this triggers re-render, just for the Add button
    setHasSelection(uniqueRows.length > 0);
  }, []);
  // const addhopitalData = () => {
  //   setHospitalData((prevData) => {
  //     const map = new Map();
  //     prevData.forEach((item) => {
  //       map.set(item._id, item);
  //     });

  //     getSelectedData.forEach((row) => {
  //       const fullRow = data.find((d) => d._id === row._id);
  //       if (fullRow) {
  //         map.set(row._id, {
  //           _id: fullRow._id,
  //           hospitalName: fullRow.organisationName,
  //           hosptalCode: fullRow.customerCode,
  //           customerCode: fullRow.customerCode,
  //           rentPerDayPrice: Number(fullRow.rentPerDayPrice ?? 0),
  //           rent7DaysPrice: Number(fullRow.rent7DaysPrice ?? 0),
  //           rent15DaysPrice: Number(fullRow.rent15DaysPrice ?? 0),
  //           rent30DaysPrice: Number(fullRow.rent30DaysPrice ?? 0),
  //           unitPrice: Number(fullRow.unitPrice ?? 0),
  //           mrPrice: Number(fullRow.mrPrice ?? 0),
  //           taxCode: Number(fullRow.taxCode ?? 0),
  //           cog: Number(fullRow.cog ?? 0),
  //           salePrice: Number(fullRow.salePrice ?? 0),
  //         });
  //       }
  //     });
  //     return Array.from(map.values());
  //   });

  //   // Clear both ref and state
  //   selectedRowIdsRef.current = new Set();
  //   setSelectedRowIds(new Set());
  //   setSelectedData([]);
  //   setToggledClearRows(prev => !prev); // ← This tells DataTable to clear checkboxes
  // };
  const addhopitalData = () => {
    const selectedRows = selectedDataRef.current;
    setHospitalData((prevData) => {
      const map = new Map();
      prevData.forEach((item) => map.set(item._id, item));
      selectedRows.forEach((row) => {
        const fullRow = data.find((d) => d._id === row._id);
        if (fullRow) {
          map.set(row._id, {
            _id: fullRow._id,
            hospitalName: fullRow.organisationName,
            hosptalCode: fullRow.customerCode,
            customerCode: fullRow.customerCode,
            rentPerDayPrice: Number(fullRow.rentPerDayPrice ?? 0),
            rent7DaysPrice: Number(fullRow.rent7DaysPrice ?? 0),
            rent15DaysPrice: Number(fullRow.rent15DaysPrice ?? 0),
            rent30DaysPrice: Number(fullRow.rent30DaysPrice ?? 0),
            unitPrice: Number(fullRow.unitPrice ?? 0),
            mrPrice: Number(fullRow.mrPrice ?? 0),
            taxCode: Number(fullRow.taxCode ?? 0),
            cog: Number(fullRow.cog ?? 0),
            salePrice: Number(fullRow.salePrice ?? 0),
          });
        }
      });
      return Array.from(map.values());
    });
    // Clear everything
    selectedRowIdsRef.current = new Set();
    selectedDataRef.current = [];
    setHasSelection(false);
    setToggledClearRows((prev) => !prev);
  };
  const deleteHospital = (id) => {
    setHospitalData((prevData) => prevData.filter((item) => item._id !== id));
  };

  const handleAttachmentDeleted = ({
    attachmentId,
    hasFiles,
    remainingCount,
  }) => {
    //  If NO files remain, clear the supportingDoc field
    if (!hasFiles) {
      setFormInputs((prev) => ({
        ...prev,
        materialAttachments: "", // ← Clear the attachment ID
      }));
      setFileDeleted(true);
    } else {
      //  If files still exist, update with new count (optional)
      console.log("Files still exist, count:", remainingCount);
    }
  };
  return (
    <>
      <Modal
        {...props}
        aria-labelledby="contained-modal-title-vcenter"
        keyboard={false}
        size="xl"
        ref={ref}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            {props?.show === "CREATE"
              ? "Create Material/Product"
              : props?.show === "DETAILS"
                ? "Material/Product Detail"
                : props?.show === "EDIT"
                  ? "Edit Material/Product"
                  : ""}{" "}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="">
          {loading ? (
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ minHeight: "200px" }}
            >
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : (
            <>
              {/* accordin1 */}
              <div
                xs={12}
                md={6}
                lg={6}
                className="commLeftRightPadding d-flex align-items-end mb-4"
              >
                {props?.show !== "DETAILS" && (
                  <Col xs={12} md={4} lg={4} className="commLeftRightPadding">
                    <FileUploadComponent
                      id="materialImage"
                      name="materialImage"
                      label="Material Image"
                      allowedTypes={["image/png", "image/jpeg"]} // ✅ only images
                      multiple={false} // ✅ only single file selection
                      required={true}
                      onSuccessUpload={onSuccessUploadDocumentType}
                      value={formInputs?.materialImage || ""}
                    />
                  </Col>
                )}
                <Col
                  xs={12}
                  md={4}
                  lg={4}
                  className="commLeftRightPadding d-flex justify-content-center align-items-center"
                >
                  <div
                    style={{ width: "100%" }}
                    className="d-flex justify-content-center align-items-center"
                  >
                    {/* {formInputs?.materialImage && (
                      <img
                        src="assets/img/newIcons/attached-file.png"
                        className="mt-1 attachmentIcon"
                        alt="attachments"
                        onClick={() =>
                          handleViewFile(formInputs?.materialImage)
                        }
                      />
                    )} */}
                    <ShowUploadImageV5 fileid={formInputs?.materialImage} />
                  </div>
                </Col>
              </div>
              <div className="accordion mb-4" id="accordionExample">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button">
                      <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                        <i
                          className={`bi ${
                            isCardVisible1
                              ? "bi-chevron-down"
                              : "bi-chevron-right"
                          }`}
                          onClick={toggleCardVisibility1}
                        ></i>
                      </Col>
                      <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                        <span className="iconLogo">BI</span>
                      </Col>
                      <Col xs={8} md={9} lg={9}>
                        <span className="headerTitle">Basic Information</span>
                        <span className="subHeaderTitle">
                          Basic Information
                        </span>
                      </Col>
                    </Row>
                  </h2>

                  <div
                    className={`accordion-collapse collapse show ${
                      isCardVisible1 ? "visible" : ""
                    }`}
                  >
                    <div className="accordion-body">
                      <Row className="pt-2 pb-4 d-flex align-items-center">
                        <Row>
                          <Col
                            xs={12}
                            md={6}
                            lg={6}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="Company Code"
                              extraLabel="Company Code"
                              placeholder=""
                              data={getCompanyCode}
                              id="companyCode"
                              iconClassName="dropdownIcon"
                              name="companyCode"
                              code="companyCodeCode"
                              description="companyCodeDesc"
                              setValue={formInputs?.companyCode || ""}
                              getvalue={setDropdownData}
                              error={validation.companyCode}
                              required={true}
                              disabled={materialMode}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={6}
                            className="commLeftRightPadding"
                          >
                            <InputField
                              placeholder=""
                              className="inputBox"
                              label="Product Code"
                              id="materialCode"
                              name="materialCode"
                              type="text"
                              value={formInputs?.materialCode || ""}
                              onChange={onInputChange}
                              disabled={materialMode}
                              error={validation?.materialCode}
                              required={true}
                            />
                          </Col>

                          <Col
                            xs={12}
                            md={6}
                            lg={6}
                            className="commLeftRightPadding"
                          >
                            {/* <ComboboxField
                              label="Category"
                              placeholder=""
                              data={categories}
                              id="category"
                              iconClassName="dropdownIcon"
                              name="category"
                              // code="categoryCode"
                              // description="categoryDesc"
                              setValue={formInputs.category || ""}
                              getvalue={setDropdownData}
                              // onChange={onInputChange}
                              // error={validation.category}
                              required={true}
                              disabled={materialMode}
                            /> */}
                            <ComboboxField
                              label="Category"
                              placeholder=""
                              data={categories}
                              id="materialGroup"
                              iconClassName="dropdownIcon"
                              name="materialGroup"
                              // code="materialGroupCode"
                              // description="materialGroupDesc"
                              setValue={formInputs?.materialGroup || ""}
                              getvalue={setDropdownData}
                              error={validation.materialGroup}
                              required={true}
                              disabled={materialMode}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={6}
                            className="commLeftRightPadding"
                          >
                            <ComboboxField
                              label="Material Sub Category"
                              placeholder=""
                              data={subCategories}
                              id="materialSubCategory"
                              iconClassName="dropdownIcon"
                              name="materialSubCategory"
                              setValue={formInputs?.materialSubCategory || ""}
                              getvalue={setDropdownData}
                              error={validation.materialSubCategory}
                              required={true}
                              disabled={materialMode}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={6}
                            className="commLeftRightPadding"
                          >
                            <TextAreaField
                              placeholder=""
                              className="inputBox"
                              label="Product Name"
                              id="materialDescription"
                              name="materialDescription"
                              type="text"
                              value={formInputs?.materialDescription || ""}
                              onChange={onInputChange}
                              disabled={materialMode}
                              required={true}
                              error={validation?.materialDescription}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={6}
                            className="commLeftRightPadding"
                          >
                            <InputField
                              placeholder=""
                              className="inputBox"
                              label="HSN Code"
                              id="hsnCode"
                              name="hsnCode"
                              type="text"
                              value={formInputs?.hsnCode || ""}
                              onChange={onInputChange}
                              disabled={materialMode}
                              required={true}
                              error={validation?.hsnCode}
                            />
                          </Col>

                          <Col
                            xs={12}
                            md={6}
                            lg={6}
                            className="commLeftRightPadding"
                          >
                            <InputField
                              placeholder=""
                              className="inputBox"
                              label="Location"
                              id="location"
                              name="location"
                              value={formInputs?.location || ""}
                              onChange={onInputChange}
                              disabled={materialMode}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={6}
                            className="commLeftRightPadding"
                          >
                            <InputField
                              placeholder=""
                              className="inputBox"
                              label="Quantity"
                              id="purchaseQuantity"
                              name="purchaseQuantity"
                              type="number"
                              value={formInputs?.purchaseQuantity ?? "1"}
                              onChange={onInputChange}
                              disabled={true}
                              // required={true}
                              error={validation?.purchaseQuantity}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={6}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              className="inputBox"
                              label="Unit"
                              placeholder=""
                              data={units}
                              name="unit"
                              code="unitCode"
                              description="unitDesc"
                              setValue={formInputs?.unit || ""}
                              getvalue={setDropdownData}
                              required={true}
                              disabled={materialMode}
                              error={validation?.unit}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={6}
                            className="commLeftRightPadding"
                          >
                            <InputField
                              placeholder=""
                              className="inputBox"
                              label="Group"
                              id="group"
                              name="group"
                              type="text"
                              value={formInputs?.group || ""}
                              onChange={onInputChange}
                              disabled={materialMode}
                              // required={true}
                              error={validation?.group}
                            />
                          </Col>
                          <Row>
                            <Col
                              xs={12}
                              md={6}
                              lg={6}
                              className="commLeftRightPadding"
                            >
                              <ComboboxField
                                label="Target Category"
                                placeholder=""
                                data={targetCategories}
                                id="targetCategory"
                                iconClassName="dropdownIcon"
                                name="targetCategory"
                                setValue={formInputs.targetCategory || ""}
                                getvalue={setDropdownData}
                                disabled={materialMode}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={6}
                              lg={6}
                              className="commLeftRightPadding"
                            >
                              <ComboboxField
                                label="Critical Product"
                                placeholder=""
                                data={selectYesOrNo}
                                id="criticalProduct"
                                iconClassName="dropdownIcon"
                                name="criticalProduct"
                                setValue={formInputs.criticalProduct || ""}
                                getvalue={setDropdownData}
                                disabled={materialMode}
                              />
                            </Col>
                            {/* Warranty field stays as-is, ADD below it: */}
                            <Col
                              xs={12}
                              md={6}
                              lg={6}
                              className="commLeftRightPadding"
                            >
                              <label htmlFor="accessories">Accessories</label>
                              <input
                                id="accessories"
                                name="accessories"
                                type="checkbox"
                                className="inputBox ms-2"
                                checked={formInputs?.accessories || false}
                                onChange={handleCheckBoxChange}
                                disabled={materialMode}
                              />
                            </Col>

                            {formInputs?.accessories && (
                              <Col
                                xs={12}
                                md={6}
                                lg={6}
                                className="commLeftRightPadding"
                              >
                                {/* <MultiselectFieldMrErf
                                  label="Accessories"
                                  data={accessoriesCode}
                                  name="accessoriesCode"
                                  id="accessoriesCode"
                                  setValue={formInputs?.accessoriesCode || []}
                                  onChangeValue={handleMultiChange}
                                  disabled={materialMode}
                                /> */}
                                <MultiselectFieldMrErf
                                  label="Accessories"
                                  data={accessoriesCode}
                                  name="accessoriesCode"
                                  id="accessoriesCode"
                                  displayField="label" // ← show combined label in dropdown
                                  valueField="materialCode" // ← unique key for selection
                                  setValue={formInputs?.accessoriesCode || []}
                                  onChangeValue={handleMultiChange}
                                  disabled={materialMode}
                                />
                              </Col>
                            )}
                          </Row>
                        </Row>
                        <Col
                          xs={12}
                          md={12}
                          lg={12}
                          className="commLeftRightPadding"
                        >
                          <hr />
                        </Col>
                        <Row>
                          <Col
                            xs={12}
                            md={6}
                            lg={6}
                            className="commLeftRightPadding"
                          >
                            <ComboboxField
                              label="Brand"
                              placeholder=""
                              data={brand}
                              id="brand"
                              iconClassName="dropdownIcon"
                              name="brand"
                              setValue={formInputs.brand || ""}
                              getvalue={setDropdownData}
                              disabled={materialMode}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={6}
                            className="commLeftRightPadding"
                          >
                            <ComboboxField
                              label="Product Type"
                              placeholder=""
                              data={productTypes}
                              id="storageLocation"
                              iconClassName="dropdownIcon"
                              name="storageLocation"
                              code="storageLocationCode"
                              description="storageLocationDesc"
                              setValue={formInputs?.storageLocation || ""}
                              getvalue={setDropdownData}
                              disabled={materialMode}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={6}
                            className="commLeftRightPadding"
                          >
                            <ComboboxField
                              label="Discarded"
                              placeholder=""
                              data={discarded}
                              id="discarded"
                              iconClassName="dropdownIcon"
                              name="discarded"
                              setValue={formInputs.discarded || ""}
                              getvalue={setDropdownData}
                              disabled={materialMode}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={6}
                            className="commLeftRightPadding"
                          >
                            <ComboboxField
                              label="Top Selling"
                              placeholder=""
                              data={selectYesOrNo}
                              id="topSelling"
                              iconClassName="dropdownIcon"
                              name="topSelling"
                              setValue={formInputs.topSelling || ""}
                              getvalue={setDropdownData}
                              disabled={materialMode}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={6}
                            className="commLeftRightPadding"
                          >
                            <InputField
                              placeholder=""
                              className="inputBox"
                              label="Warranty"
                              id="warranty"
                              name="warranty"
                              type="text"
                              value={formInputs?.warranty || ""}
                              onChange={onInputChange}
                              disabled={materialMode}
                              error={validation?.warranty}
                            />
                          </Col>
                        </Row>
                        <Col
                          xs={12}
                          md={12}
                          lg={12}
                          className="commLeftRightPadding"
                        >
                          <hr />{" "}
                          <p className="fw-bold text-primary">Price Details</p>
                        </Col>
                        <Row>
                          <Col
                            xs={12}
                            md={6}
                            lg={6}
                            className="commLeftRightPadding"
                          >
                            <InputField
                              placeholder=""
                              className="inputBox"
                              label="Vendor Rate (Unit Price)"
                              id="unitPrice"
                              name="unitPrice"
                              type="number"
                              value={formInputs?.unitPrice ?? ""}
                              onChange={onInputChange}
                              disabled={materialMode}
                              error={validation?.unitPrice}
                              required={true}
                            />
                          </Col>

                          <Col
                            xs={12}
                            md={6}
                            lg={6}
                            className="commLeftRightPadding"
                          >
                            <InputField
                              placeholder=""
                              className="inputBox"
                              label="MRP"
                              id="mrPrice"
                              name="mrPrice"
                              type="number"
                              value={formInputs?.mrPrice ?? ""}
                              onChange={onInputChange}
                              disabled={materialMode}
                              error={validation?.mrPrice}
                              required={true}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={6}
                            className="commLeftRightPadding"
                          >
                            <InputField
                              placeholder=""
                              className="inputBox"
                              label="GST"
                              id="taxCode"
                              name="taxCode"
                              type="number"
                              value={formInputs?.taxCode ?? ""}
                              onChange={onInputChange}
                              disabled={materialMode}
                              required={true}
                              error={validation?.taxCode}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={6}
                            className="commLeftRightPadding"
                          >
                            <InputField
                              placeholder=""
                              className="inputBox"
                              label="COG"
                              id="cog"
                              name="cog"
                              type="number"
                              min={0}
                              value={formInputs?.cog ?? ""}
                              onChange={onInputChange}
                              disabled={materialMode}
                              error={validation?.cog}
                            />
                          </Col>
                        </Row>
                        <Col
                          xs={12}
                          md={12}
                          lg={12}
                          className="commLeftRightPadding"
                        >
                          <hr />{" "}
                          <p className="fw-bold text-primary">
                            Sales Price Details
                          </p>
                        </Col>
                        <Row>
                          <Col
                            xs={12}
                            md={6}
                            lg={6}
                            className="commLeftRightPadding"
                          >
                            <InputField
                              placeholder=""
                              className="inputBox"
                              label="Sale Price"
                              id="salePrice"
                              name="salePrice"
                              type="text"
                              value={formInputs?.salePrice ?? ""}
                              onChange={onInputChange}
                              disabled={materialMode}
                              error={validation?.salePrice}
                              required={true}
                            />
                          </Col>
                          {/* <Col
                            xs={12}
                            md={6}
                            lg={6}
                            className="commLeftRightPadding"
                          >
                            <InputField
                              placeholder=""
                              className="inputBox"
                              label="IPHSLR Price"
                              id="iphslrPrice"
                              name="iphslrPrice"
                              type="text"
                              value={formInputs?.iphslrPrice || ""}
                              onChange={onInputChange}
                              disabled={materialMode}
                              error={validation?.iphslrPrice}
                              required={true}
                            />
                          </Col> */}
                          {/* <Col
                            xs={12}
                            md={6}
                            lg={6}
                            className="commLeftRightPadding"
                          >
                            <InputField
                              placeholder=""
                              className="inputBox"
                              label="PCDLR Price"
                              id="pcdlrPrice"
                              name="pcdlrPrice"
                              type="text"
                              value={formInputs?.pcdlrPrice || ""}
                              onChange={onInputChange}
                              disabled={materialMode}
                              error={validation?.pcdlrPrice}
                              required={true}
                            />
                          </Col> */}
                        </Row>
                        <Col
                          xs={12}
                          md={12}
                          lg={12}
                          className="commLeftRightPadding"
                        >
                          <hr />{" "}
                          <p className="fw-bold text-primary">
                            Rent Price Details
                          </p>
                        </Col>
                        <Row>
                          <Col
                            xs={12}
                            md={6}
                            lg={6}
                            className="commLeftRightPadding"
                          >
                            <InputField
                              placeholder=""
                              className="inputBox"
                              label="Rent Per Day"
                              id="rentPerDayPrice"
                              name="rentPerDayPrice"
                              type="number"
                              value={formInputs?.rentPerDayPrice ?? ""}
                              onChange={onInputChange}
                              disabled={materialMode}
                              required={true}
                              error={validation?.rentPerDayPrice}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={6}
                            className="commLeftRightPadding"
                          >
                            <InputField
                              placeholder=""
                              className="inputBox"
                              label="Rent 7 Days"
                              id="rent7DaysPrice"
                              name="rent7DaysPrice"
                              type="number"
                              value={formInputs?.rent7DaysPrice ?? ""}
                              onChange={onInputChange}
                              disabled={materialMode}
                              required={true}
                              error={validation?.rent7DaysPrice}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={6}
                            className="commLeftRightPadding"
                          >
                            <InputField
                              placeholder=""
                              className="inputBox"
                              label="Rent 15 Days"
                              id="rent15DaysPrice"
                              name="rent15DaysPrice"
                              type="number"
                              value={formInputs?.rent15DaysPrice ?? ""}
                              onChange={onInputChange}
                              disabled={materialMode}
                              required={true}
                              error={validation?.rent15DaysPrice}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={6}
                            className="commLeftRightPadding"
                          >
                            <InputField
                              placeholder=""
                              className="inputBox"
                              label="Rent 30 Days"
                              id="rent30DaysPrice"
                              name="rent30DaysPrice"
                              type="number"
                              value={formInputs?.rent30DaysPrice ?? ""}
                              onChange={onInputChange}
                              disabled={materialMode}
                              required={true}
                              error={validation?.rent30DaysPrice}
                            />
                          </Col>
                        </Row>

                        <Col
                          xs={12}
                          md={12}
                          lg={12}
                          className="commLeftRightPadding"
                        >
                          <hr />{" "}
                          <p className="fw-bold text-primary">
                            Security Deposit
                          </p>
                        </Col>
                        <Row>
                          <Col
                            xs={12}
                            md={6}
                            lg={6}
                            className="commLeftRightPadding"
                          >
                            <InputField
                              placeholder=""
                              className="inputBox"
                              label="Security Amt"
                              id="securityAmt"
                              name="securityAmt"
                              type="number"
                              value={formInputs?.securityAmt ?? ""}
                              onChange={onInputChange}
                              disabled={materialMode}
                              error={validation?.securityAmt}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={6}
                            className="commLeftRightPadding"
                          >
                            <InputField
                              placeholder=""
                              className="inputBox"
                              label="Lock In Period"
                              id="lockInPeriod"
                              name="lockInPeriod"
                              type="number"
                              value={formInputs?.lockInPeriod ?? ""}
                              onChange={onInputChange}
                              disabled={materialMode}
                              error={validation?.lockInPeriod}
                            />
                          </Col>
                        </Row>
                        <Col
                          xs={12}
                          md={12}
                          lg={12}
                          className="commLeftRightPadding"
                        >
                          <hr />{" "}
                        </Col>

                        <Row>
                          <Col
                            xs={12}
                            md={6}
                            lg={6}
                            className="commLeftRightPadding"
                          >
                            <ComboboxField
                              label="Type"
                              placeholder=""
                              data={types}
                              id="type"
                              iconClassName="dropdownIcon"
                              name="type"
                              code="typeCode"
                              description="typeDesc"
                              setValue={formInputs?.type || ""}
                              getvalue={setDropdownData}
                              disabled={materialMode}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={6}
                            className="commLeftRightPadding"
                          >
                            <ComboboxField
                              label="Imported By"
                              placeholder=""
                              data={importedBy}
                              id="importedBy"
                              iconClassName="dropdownIcon"
                              name="importedBy"
                              //   code="importedByCode"
                              //  description="importedByDesc"
                              setValue={formInputs?.importedBy || ""}
                              getvalue={setDropdownData}
                              disabled={materialMode}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={6}
                            className="commLeftRightPadding"
                          >
                            <InputField
                              placeholder=""
                              className="inputBox"
                              label="Size"
                              id="size"
                              name="size"
                              type="text"
                              value={formInputs?.size || ""}
                              onChange={onInputChange}
                              disabled={materialMode}
                              error={validation?.size}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={6}
                            className="commLeftRightPadding"
                          >
                            <InputField
                              placeholder=""
                              className="inputBox"
                              label="Product Contains"
                              id="productContains"
                              name="productContains"
                              type="text"
                              value={formInputs?.productContains || ""}
                              onChange={onInputChange}
                              disabled={materialMode}
                              error={validation?.productContains}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={6}
                            className="commLeftRightPadding"
                          >
                            <ComboboxField
                              label="Mfg By"
                              placeholder=""
                              data={mfgBy}
                              id="mfgBy"
                              iconClassName="dropdownIcon"
                              name="mfgBy"
                              code="mfgByCode"
                              description="mfgByDesc"
                              setValue={formInputs?.mfgBy || ""}
                              getvalue={setDropdownData}
                              disabled={materialMode}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={6}
                            className="commLeftRightPadding"
                          >
                            <ComboboxField
                              label="Mkt By"
                              placeholder=""
                              data={mktBy}
                              id="mktBy"
                              iconClassName="dropdownIcon"
                              name="mktBy"
                              code="mktByCode"
                              description="mktByDesc"
                              setValue={formInputs?.mktBy || ""}
                              getvalue={setDropdownData}
                              disabled={materialMode}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={6}
                            className="commLeftRightPadding"
                          >
                            <ComboboxField
                              label="MRP Status"
                              placeholder=""
                              data={selectYesOrNo}
                              id="mrpStatus"
                              iconClassName="dropdownIcon"
                              name="mrpStatus"
                              //   code="mrpStatusCode"
                              //  description="mrpStatusDesc"
                              setValue={formInputs?.mrpStatus || ""}
                              getvalue={setDropdownData}
                              disabled={materialMode}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={6}
                            className="commLeftRightPadding"
                          >
                            <InputField
                              placeholder=""
                              className="inputBox"
                              label="Norma P Code"
                              id="normaPCode"
                              name="normaPCode"
                              type="text"
                              value={formInputs?.normaPCode || ""}
                              onChange={onInputChange}
                              disabled={materialMode}
                              error={validation?.normaPCode}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={6}
                            className="commLeftRightPadding"
                          >
                            <InputField
                              placeholder=""
                              className="inputBox"
                              label="Norma Transfer Rate"
                              id="normaTransferRate"
                              name="normaTransferRate"
                              type="text"
                              value={formInputs?.normaTransferRate || ""}
                              onChange={onInputChange}
                              disabled={materialMode}
                              error={validation?.normaTransferRate}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={6}
                            className="commLeftRightPadding"
                          >
                            <InputField
                              placeholder=""
                              className="inputBox"
                              label="ASF Rate"
                              id="asfRate"
                              name="asfRate"
                              type="text"
                              value={formInputs?.asfRate || ""}
                              onChange={onInputChange}
                              disabled={materialMode}
                              error={validation?.asfRate}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={6}
                            className="commLeftRightPadding"
                          >
                            <InputField
                              placeholder=""
                              className="inputBox"
                              label="Product From"
                              id="productFrom"
                              name="productFrom"
                              type="text"
                              value={formInputs?.productFrom || ""}
                              onChange={onInputChange}
                              disabled={materialMode}
                              error={validation?.productFrom}
                            />
                          </Col>
                        </Row>
                        <Col
                          xs={12}
                          md={6}
                          lg={6}
                          className="commLeftRightPadding"
                        >
                          <TextAreaField
                            placeholder=""
                            className="inputBox"
                            label="Remarks"
                            id="remarks"
                            name="remarks"
                            value={formInputs?.remarks || ""}
                            onChange={onInputChange}
                            disabled={materialMode}
                            error={validation?.remarks}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={6}
                          className="commTopButtonRightLeftPadding d-flex align-items-center"
                        >
                          <div>
                            <label
                              className="form-check-label fw-medium fs-6 text-dark mb-2 cursor-pointer me-2"
                              htmlFor="activeInactive"
                            >
                              Active/Inactive
                            </label>
                          </div>
                          <div className="form-check form-switch">
                            <input
                              className="form-check-input custom-switch"
                              type="checkbox"
                              role="switch"
                              name="activeInactive"
                              id="activeInactive"
                              checked={formInputs?.activeInactive || false}
                              disabled={materialMode}
                              onChange={(e) =>
                                setFormInputs((prev) => ({
                                  ...prev,
                                  activeInactive: e.target.checked,
                                }))
                              }
                              // disabled={editMode}
                            />
                            <span className="ms-2">
                              {formInputs?.activeInactive
                                ? "Active"
                                : "Inactive"}
                            </span>
                          </div>
                        </Col>

                        <Col
                          xs={12}
                          md={6}
                          lg={6}
                          className="commLeftRightPadding"
                        >
                          {/* <FileUploadComponent
                            id="materialAttachments"
                            name="materialAttachments"
                            label="Material Attachments"
                            allowedTypes={[
                              "image/png",
                              "image/jpeg",
                              "application/pdf",
                            ]}
                            multiple={true} // Change to false for single file selection
                            onSuccessUpload={onSuccessUploadDocumentType}
                            value={formInputs?.materialAttachments || ""}
                            error={validation?.materialAttachments}
                          /> */}
                          <FileUploadComponentForHB
                            id="materialAttachments"
                            name="materialAttachments"
                            label="Material Attachments"
                            allowedTypes={[
                              "image/png",
                              "image/jpeg",
                              "application/pdf",
                            ]}
                            multiple={true} // Change to false for single file selection
                            // required={true}
                            onSuccessUpload={onSuccessUploadDocumentType}
                            value={formInputs?.materialAttachments || ""}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={6}
                          className="commLeftRightPadding"
                        >
                          {formInputs?.materialAttachments && (
                            // <ShowUploadImage  fileid= {formInputs?.materialAttachments}/>
                            // <ShowUploadImage fileid={formInputs?.materialAttachment || formInputs?.materialAttachments} />

                            <img
                              src="assets/img/newIcons/attached-file.png"
                              className="mt-1 attachmentIcon"
                              alt="attachments"
                              onClick={() =>
                                handleViewFile(formInputs?.materialAttachments)
                              }
                            />
                          )}
                        </Col>

                        {(props?.show === "CREATE" || props?.show === "EDIT") &&
                          !materialMode && (
                            <>
                              <Row>
                                <Col
                                  xs={12}
                                  md={12}
                                  lg={12}
                                  className="commLeftRightPadding"
                                >
                                  <hr />
                                </Col>
                                <Col
                                  xs={12}
                                  md={6}
                                  lg={6}
                                  className="commLeftRightPadding"
                                >
                                  <p className="fw-bold text-primary">
                                    Select Hosipital Perecentage
                                  </p>
                                </Col>
                                <Col
                                  xs={12}
                                  md={2}
                                  lg={2}
                                  className="commLeftRightPadding"
                                >
                                  {/*   <button
                                    className="btn btnTable"
                                    onClick={addhopitalData}
                                    disabled={!getSelectedData?.length}
                                  >
                                    <i class="bi bi-house-add mx-2"></i>
                                    Add
                                  </button> */}
                                  <button
                                    className="btn btnTable"
                                    onClick={addhopitalData}
                                    disabled={!hasSelection}
                                  >
                                    <i className="bi bi-house-add mx-2"></i>
                                    Add
                                  </button>
                                </Col>
                                <Col
                                  xs={12}
                                  md={4}
                                  lg={4}
                                  className="commLeftRightPadding"
                                >
                                  <SearchField
                                    name="searchKey"
                                    value={getCommonSearchTxt}
                                    onChange={(event) =>
                                      setCommonSearchTxt(event.target.value)
                                    }
                                    onClick={() => handleSearchFuncApi()}
                                  />
                                </Col>
                              </Row>

                              <Row>
                                <Col xs={12} md={12} lg={12}>
                                  <DataTable
                                    title=""
                                    columns={columns}
                                    data={data}
                                    progressPending={loading}
                                    paginationRowsPerPageOptions={
                                      CustomerConstants.ROW_PER_PAGE
                                    }
                                    pagination
                                    paginationServer
                                    paginationTotalRows={totalRows}
                                    onChangeRowsPerPage={handlePerRowsChange}
                                    onChangePage={handlePageChange}
                                    selectableRows
                                    onSelectedRowsChange={handleChangeCat}
                                    selectableRowSelected={(row) =>
                                      selectedRowIdsRef.current.has(row._id)
                                    }
                                    clearSelectedRows={toggledClearRows} // ← ADD THIS
                                  />
                                </Col>
                              </Row>
                            </>
                          )}

                        <Row>
                          <Col
                            xs={12}
                            md={12}
                            lg={12}
                            className="commLeftRightPadding"
                          >
                            <hr />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={6}
                            className="commLeftRightPadding"
                          >
                            <p className="fw-bold text-primary">
                              Selected Hosipital Perecentage
                            </p>
                          </Col>
                        </Row>

                        <Row>
                          <Col xs={12} md={12} lg={12}>
                            <DataTable
                              title=""
                              columns={hospitalColumns}
                              data={hospital}
                              progressPending={loading}
                              paginationRowsPerPageOptions={
                                CustomerConstants.ROW_PER_PAGE
                              }
                              pagination
                              // paginationServer
                              // paginationTotalRows={totalRows}
                              // onChangeRowsPerPage={handlePerRowsChange}
                              // onChangePage={handlePageChange}
                              // selectableRows
                              onSelectedRowsChange={handleChangeCat}
                            />
                          </Col>
                        </Row>

                        {/* <Col xs={12} md={6} lg={6} className="commLeftRightPadding">
                      <InputField
                        placeholder=""
                        className="inputBox"
                        label="Weight Pice"
                        id="weightPice"
                        name="weightPice"
                        type="text"
                        value={formInputs.weightPice || ""}
                        // onChange={onInputChange}
                        disabled={true}
                      />
                    </Col>
                    <Col xs={12} md={6} lg={6} className="commLeftRightPadding">
                      <InputField
                        placeholder=""
                        className="inputBox"
                        label="Weight Total"
                        id="weightTotal"
                        name="weightTotal"
                        type="text"
                        value={formInputs.weightTotal || ""}
                        // onChange={onInputChange}
                        disabled={true}
                      />
                    </Col>
                    <Col xs={12} md={6} lg={6} className="commLeftRightPadding">
                      <InputField
                        placeholder=""
                        className="inputBox"
                        label="Book Price"
                        id="bookPrice"
                        name="bookPrice"
                        type="text"
                        value={formInputs.bookPrice || ""}
                        // onChange={onInputChange}
                        disabled={true}
                      />
                    </Col>
                    <Col xs={12} md={6} lg={6} className="commLeftRightPadding">
                      <InputField
                        placeholder=""
                        className="inputBox"
                        label="Book Total Price"
                        id="bookTotalPrice"
                        name="bookTotalPrice"
                        type="text"
                        value={formInputs.bookTotalPrice || ""}
                        // onChange={onInputChange}
                        disabled={true}
                      />
                    </Col> */}

                        <Col xs={12} md={12} lg={12}></Col>
                      </Row>
                    </div>
                  </div>
                </div>
              </div>
              {props.show !== "DETAILS" && (
                <div className="space-y-4">
                  <Row className="justify-end">
                    <Col xs={6} md={3} lg={3} className="commLeftRightPadding">
                      <button
                        type="button"
                        onClick={() => props.onHide()}
                        className="btn btn-danger mt-4 w-full justify-center rounded-md"
                      >
                        Cancel
                      </button>
                    </Col>
                    {props.show === "CREATE" && (
                      <Col
                        xs={6}
                        md={3}
                        lg={3}
                        className="commLeftRightPadding"
                      >
                        <button
                          onClick={handleSubmit}
                          disabled={materialMode}
                          className="btn btn-primary mt-4 w-full justify-center rounded-md"
                        >
                          Save
                        </button>
                      </Col>
                    )}
                    {props.show === "EDIT" && (
                      <Col
                        xs={6}
                        md={3}
                        lg={3}
                        className="commLeftRightPadding"
                      >
                        <button
                          onClick={handleUpdate}
                          // disabled={materialMode}
                          disabled={disabled}
                          className="btn btn-primary mt-4 w-full justify-center rounded-md"
                        >
                          Update
                        </button>
                      </Col>
                    )}
                    <Col
                      xs={12}
                      md={12}
                      lg={12}
                      className="commLeftRightPadding"
                    >
                      {/* <p className="errorMsg"> {errorMsg} </p> */}
                    </Col>
                  </Row>
                </div>
              )}
            </>
          )}
        </Modal.Body>
      </Modal>

      {/* <FileViewerModal
        show={getShowFileViewModal}
        onHide={handleViewFileHide}
        fileid={getFileViewData}
      /> */}
      <FileViewerModalForHB
        show={getShowFileViewModal}
        onHide={handleViewFileHide}
        fileid={getFileViewData}
        onDeleteSuccess={handleAttachmentDeleted}
      />
      <FailureModal
        show={getShowFailureModal}
        onHide={() => hideFailureModal()}
        failuremodaldata={failureModalData}
        requiredfields={getErrorFields}
      />
    </>
  );
});

export default MaterialHBModalV5;
